{
  "apis": {
    "openai": {
      "baseurl": "https://api.openai.com/v1/",
      "token": "",
      "proxy": true
    },
    "anthropic": {
      "baseurl": "anthropic://",
      "token": "",
      "proxy": true
    },
    "openrouter": {
      "baseurl": "https://openrouter.ai/api/v1/",
      "token": "",
      "proxy": true
    },
    "google": {
      "baseurl": "google://",
      "token": "",
      "proxy": true
    },
    "deepseek": {
      "baseurl": "https://api.deepseek.com/v1/",
      "token": "",
      "proxy": true
    },
    "hyperbolic": {
      "baseurl": "https://api.hyperbolic.xyz/v1/",
      "token": "",
      "proxy": true
    },
    "xai": {
      "baseurl": "https://api.x.ai/v1/",
      "token": "",
      "proxy": true
    },
    "together": {
      "baseurl": "https://api.together.xyz/v1/",
      "token": "",
      "proxy": true
    },
    "fireworks": {
      "baseurl": "https://api.fireworks.ai/inference/v1/",
      "token": "",
      "proxy": true
    },
    "groq": {
      "baseurl": "https://api.groq.com/openai/v1/",
      "token": "",
      "proxy": true
    },
    "google_": {
      "baseurl": "https://generativelanguage.googleapis.com/v1beta/",
      "token": "",
      "proxy": true
    },
    "cerebras": {
      "baseurl": "https://api.cerebras.ai/v1/",
      "token": "",
      "proxy": true
    },
    "minimax": {
      "baseurl": "https://api.minimax.io/v1/",
      "token": "",
      "proxy": true
    },
    "opencode-go": {
      "baseurl": "https://opencode.ai/zen/go/v1/",
      "token": "",
      "proxy": true
    },
    "codex": {
      "baseurl": "codex://",
      "token": "",
      "proxy": true
    }
  },
  "models": [
    {
      "api": "fireworks",
      "id": "accounts/fireworks/models/llama-v3p1-405b-instruct",
      "name": "llama-v3p1-405b-instruct",
      "max_tokens": 4096
    },
    {
      "api": "together",
      "id": "meta-llama/Meta-Llama-3.1-405B-Instruct-Turbo",
      "name": "Meta-Llama-3.1-405B-Instruct-Turbo",
      "max_tokens": 4096
    },
    {
      "api": "hyperbolic",
      "id": "meta-llama/Meta-Llama-3.1-405B-Instruct",
      "name": "Meta-Llama-3.1-405B-Instruct",
      "max_tokens": 8192
    },
    {
      "api": "hyperbolic",
      "id": "meta-llama/Meta-Llama-3.1-405B",
      "name": "Meta-Llama-3.1-405B",
      "max_tokens": 32768,
      "completion": true
    },
    {
      "api": "hyperbolic",
      "id": "meta-llama/Meta-Llama-3.1-405B-FP8",
      "name": "Meta-Llama-3.1-405B-FP8",
      "max_tokens": 32764,
      "completion": true
    },
    {
      "api": "hyperbolic",
      "id": "NousResearch/Hermes-3-Llama-3.1-70B",
      "name": "Hermes-3-Llama-3.1-70B",
      "max_tokens": 12288
    },
    {
      "api": "groq",
      "id": "llama-3.1-8b-instant",
      "name": "groq/llama-3.1-8b-instant",
      "max_tokens": 4096
    },
    {
      "api": "deepseek",
      "id": "deepseek-chat",
      "name": "deepseek-chat",
      "max_tokens": 8192
    },
    {
      "api": "deepseek",
      "id": "deepseek-reasoner",
      "name": "deepseek-reasoner",
      "max_tokens": 64000
    },
    {
      "api": "deepseek",
      "id": "deepseek-flash",
      "name": "deepseek-flash",
      "max_tokens": 384000,
      "params": [
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "high",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        }
      ]
    },
    {
      "api": "deepseek",
      "id": "deepseek-v4-pro",
      "name": "deepseek-v4-pro",
      "max_tokens": 384000,
      "params": [
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "max",
          "options": [
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        }
      ]
    },
    {
      "api": "xai",
      "id": "grok-4",
      "name": "grok-4"
    },
    {
      "api": "xai",
      "id": "grok-3",
      "name": "grok-3"
    },
    {
      "api": "xai",
      "id": "grok-3-mini",
      "name": "grok-3-mini"
    },
    {
      "api": "cerebras",
      "id": "qwen-3-32b",
      "name": "qwen-3-32b",
      "max_tokens": 16385
    },
    {
      "api": "minimax",
      "id": "MiniMax-M2",
      "name": "MiniMax-M2",
      "max_tokens": 128000,
      "params": [
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_split",
          "key": "reasoning_split",
          "label": "Reasoning Split",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Put into thinking"
            },
            {
              "value": false,
              "label": "Put into content"
            }
          ]
        }
      ]
    },
    {
      "api": "anthropic",
      "id": "claude-opus-4-20250514",
      "name": "claude-opus-4-20250514",
      "max_tokens": 32000
    },
    {
      "api": "anthropic",
      "id": "claude-sonnet-4-20250514",
      "name": "claude-sonnet-4-20250514",
      "max_tokens": 64000
    },
    {
      "api": "anthropic",
      "id": "claude-3-7-sonnet-20250219",
      "name": "claude-3-7-sonnet-20250219",
      "max_tokens": 64000
    },
    {
      "api": "anthropic",
      "id": "claude-3-5-sonnet-20241022",
      "name": "claude-3-5-sonnet-20241022",
      "max_tokens": 8192
    },
    {
      "api": "anthropic",
      "id": "claude-3-5-haiku-20241022",
      "name": "claude-3-5-haiku-20241022",
      "max_tokens": 8192
    },
    {
      "api": "anthropic",
      "id": "claude-3-5-sonnet-20240620",
      "name": "claude-3-5-sonnet-20240620",
      "max_tokens": 8192
    },
    {
      "api": "anthropic",
      "id": "claude-3-haiku-20240307",
      "name": "claude-3-haiku-20240307",
      "max_tokens": 4096
    },
    {
      "api": "anthropic",
      "id": "claude-3-opus-20240229",
      "name": "claude-3-opus-20240229",
      "max_tokens": 4096
    },
    {
      "api": "anthropic",
      "id": "claude-3-sonnet-20240229",
      "name": "claude-3-sonnet-20240229",
      "max_tokens": 4096
    },
    {
      "api": "anthropic",
      "id": "claude-2.1",
      "name": "claude-2.1",
      "max_tokens": 4096
    },
    {
      "api": "anthropic",
      "id": "claude-2.0",
      "name": "claude-2.0",
      "max_tokens": 4096
    },
    {
      "api": "google",
      "id": "gemini-2.5-flash",
      "name": "gemini-2.5-flash",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-2.5-pro",
      "name": "gemini-2.5-pro",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-2.0-flash",
      "name": "gemini-2.0-flash",
      "max_tokens": 8192
    },
    {
      "api": "google",
      "id": "gemini-2.0-flash-001",
      "name": "gemini-2.0-flash-001",
      "max_tokens": 8192
    },
    {
      "api": "google",
      "id": "gemini-2.0-flash-exp-image-generation",
      "name": "gemini-2.0-flash-exp-image-generation",
      "max_tokens": 8192
    },
    {
      "api": "google",
      "id": "gemini-2.0-flash-lite-001",
      "name": "gemini-2.0-flash-lite-001",
      "max_tokens": 8192
    },
    {
      "api": "google",
      "id": "gemini-2.0-flash-lite",
      "name": "gemini-2.0-flash-lite",
      "max_tokens": 8192
    },
    {
      "api": "google",
      "id": "gemini-2.5-flash-preview-tts",
      "name": "gemini-2.5-flash-preview-tts",
      "max_tokens": 16384
    },
    {
      "api": "google",
      "id": "gemini-2.5-pro-preview-tts",
      "name": "gemini-2.5-pro-preview-tts",
      "max_tokens": 16384
    },
    {
      "api": "google",
      "id": "gemma-3-1b-it",
      "name": "gemma-3-1b-it",
      "max_tokens": 8192
    },
    {
      "api": "google",
      "id": "gemma-3-4b-it",
      "name": "gemma-3-4b-it",
      "max_tokens": 8192
    },
    {
      "api": "google",
      "id": "gemma-3-12b-it",
      "name": "gemma-3-12b-it",
      "max_tokens": 8192
    },
    {
      "api": "google",
      "id": "gemma-3-27b-it",
      "name": "gemma-3-27b-it",
      "max_tokens": 8192
    },
    {
      "api": "google",
      "id": "gemma-3n-e4b-it",
      "name": "gemma-3n-e4b-it",
      "max_tokens": 2048
    },
    {
      "api": "google",
      "id": "gemma-3n-e2b-it",
      "name": "gemma-3n-e2b-it",
      "max_tokens": 2048
    },
    {
      "api": "google",
      "id": "gemini-flash-latest",
      "name": "gemini-flash-latest",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-flash-lite-latest",
      "name": "gemini-flash-lite-latest",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-pro-latest",
      "name": "gemini-pro-latest",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-2.5-flash-lite",
      "name": "gemini-2.5-flash-lite",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-2.5-flash-image",
      "name": "gemini-2.5-flash-image",
      "max_tokens": 32768
    },
    {
      "api": "google",
      "id": "gemini-2.5-flash-lite-preview-09-2025",
      "name": "gemini-2.5-flash-lite-preview-09-2025",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-3-pro-preview",
      "name": "gemini-3-pro-preview",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-3-flash-preview",
      "name": "gemini-3-flash-preview",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-3.1-pro-preview",
      "name": "gemini-3.1-pro-preview",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-3.1-pro-preview-customtools",
      "name": "gemini-3.1-pro-preview-customtools",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-3.1-flash-lite-preview",
      "name": "gemini-3.1-flash-lite-preview",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-3-pro-image-preview",
      "name": "gemini-3-pro-image-preview",
      "max_tokens": 32768
    },
    {
      "api": "google",
      "id": "nano-banana-pro-preview",
      "name": "nano-banana-pro-preview",
      "max_tokens": 32768
    },
    {
      "api": "google",
      "id": "gemini-3.1-flash-image-preview",
      "name": "gemini-3.1-flash-image-preview",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-robotics-er-1.5-preview",
      "name": "gemini-robotics-er-1.5-preview",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "gemini-2.5-computer-use-preview-10-2025",
      "name": "gemini-2.5-computer-use-preview-10-2025",
      "max_tokens": 65536
    },
    {
      "api": "google",
      "id": "deep-research-pro-preview-12-2025",
      "name": "deep-research-pro-preview-12-2025",
      "max_tokens": 65536
    },
    {
      "api": "openai",
      "id": "gpt-3.5-turbo",
      "name": "gpt-3.5-turbo",
      "max_tokens": 16385
    },
    {
      "api": "openai",
      "id": "gpt-3.5-turbo-0125",
      "name": "gpt-3.5-turbo-0125",
      "max_tokens": 16385
    },
    {
      "api": "openai",
      "id": "gpt-3.5-turbo-1106",
      "name": "gpt-3.5-turbo-1106",
      "max_tokens": 16385
    },
    {
      "api": "openai",
      "id": "gpt-3.5-turbo-16k",
      "name": "gpt-3.5-turbo-16k",
      "max_tokens": 16385
    },
    {
      "api": "openai",
      "id": "gpt-3.5-turbo-instruct",
      "name": "gpt-3.5-turbo-instruct",
      "max_tokens": 4096,
      "completion": true
    },
    {
      "api": "openai",
      "id": "gpt-3.5-turbo-instruct-0914",
      "name": "gpt-3.5-turbo-instruct-0914",
      "max_tokens": 4096,
      "completion": true
    },
    {
      "api": "openai",
      "id": "gpt-4",
      "name": "gpt-4",
      "max_tokens": 8192
    },
    {
      "api": "openai",
      "id": "gpt-4-0125-preview",
      "name": "gpt-4-0125-preview",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4-0314",
      "name": "gpt-4-0314",
      "max_tokens": 8192
    },
    {
      "api": "openai",
      "id": "gpt-4-0613",
      "name": "gpt-4-0613",
      "max_tokens": 8192
    },
    {
      "api": "openai",
      "id": "gpt-4-1106-preview",
      "name": "gpt-4-1106-preview",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4-turbo",
      "name": "gpt-4-turbo",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4-turbo-2024-04-09",
      "name": "gpt-4-turbo-2024-04-09",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4.1",
      "name": "gpt-4.1",
      "max_tokens": 32768
    },
    {
      "api": "openai",
      "id": "gpt-4.1-2025-04-14",
      "name": "gpt-4.1-2025-04-14",
      "max_tokens": 32768
    },
    {
      "api": "openai",
      "id": "gpt-4.1-mini",
      "name": "gpt-4.1-mini",
      "max_tokens": 32768
    },
    {
      "api": "openai",
      "id": "gpt-4.1-mini-2025-04-14",
      "name": "gpt-4.1-mini-2025-04-14",
      "max_tokens": 32768
    },
    {
      "api": "openai",
      "id": "gpt-4.1-nano",
      "name": "gpt-4.1-nano",
      "max_tokens": 32768
    },
    {
      "api": "openai",
      "id": "gpt-4.1-nano-2025-04-14",
      "name": "gpt-4.1-nano-2025-04-14",
      "max_tokens": 32768
    },
    {
      "api": "openai",
      "id": "gpt-4o",
      "name": "gpt-4o",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4o-2024-05-13",
      "name": "gpt-4o-2024-05-13",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4o-2024-08-06",
      "name": "gpt-4o-2024-08-06",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4o-2024-11-20",
      "name": "gpt-4o-2024-11-20",
      "max_tokens": 16384
    },
    {
      "api": "openai",
      "id": "gpt-4o-mini",
      "name": "gpt-4o-mini",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4o-mini-2024-07-18",
      "name": "gpt-4o-mini-2024-07-18",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4o-mini-search-preview",
      "name": "gpt-4o-mini-search-preview",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4o-mini-search-preview-2025-03-11",
      "name": "gpt-4o-mini-search-preview-2025-03-11",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4o-search-preview",
      "name": "gpt-4o-search-preview",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-4o-search-preview-2025-03-11",
      "name": "gpt-4o-search-preview-2025-03-11",
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-5",
      "name": "gpt-5",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-2025-08-07",
      "name": "gpt-5-2025-08-07",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-chat-latest",
      "name": "gpt-5-chat-latest",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-codex",
      "name": "gpt-5-codex",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-mini",
      "name": "gpt-5-mini",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-mini-2025-08-07",
      "name": "gpt-5-mini-2025-08-07",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-nano",
      "name": "gpt-5-nano",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-nano-2025-08-07",
      "name": "gpt-5-nano-2025-08-07",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-pro",
      "name": "gpt-5-pro",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-pro-2025-10-06",
      "name": "gpt-5-pro-2025-10-06",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-search-api",
      "name": "gpt-5-search-api",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5-search-api-2025-10-14",
      "name": "gpt-5-search-api-2025-10-14",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.1",
      "name": "gpt-5.1",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.1-2025-11-13",
      "name": "gpt-5.1-2025-11-13",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.1-chat-latest",
      "name": "gpt-5.1-chat-latest",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.1-codex",
      "name": "gpt-5.1-codex",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.1-codex-max",
      "name": "gpt-5.1-codex-max",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.1-codex-mini",
      "name": "gpt-5.1-codex-mini",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.2",
      "name": "gpt-5.2",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.2-2025-12-11",
      "name": "gpt-5.2-2025-12-11",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.2-chat-latest",
      "name": "gpt-5.2-chat-latest",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.2-codex",
      "name": "gpt-5.2-codex",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.2-pro",
      "name": "gpt-5.2-pro",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.2-pro-2025-12-11",
      "name": "gpt-5.2-pro-2025-12-11",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.3-chat-latest",
      "name": "gpt-5.3-chat-latest",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.3-codex",
      "name": "gpt-5.3-codex",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.4",
      "name": "gpt-5.4",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.4-2026-03-05",
      "name": "gpt-5.4-2026-03-05",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.4-mini",
      "name": "gpt-5.4-mini",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.4-mini-2026-03-17",
      "name": "gpt-5.4-mini-2026-03-17",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.4-nano",
      "name": "gpt-5.4-nano",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.4-nano-2026-03-17",
      "name": "gpt-5.4-nano-2026-03-17",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.4-pro",
      "name": "gpt-5.4-pro",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.4-pro-2026-03-05",
      "name": "gpt-5.4-pro-2026-03-05",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.5",
      "name": "gpt-5.5",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.5-2026-04-23",
      "name": "gpt-5.5-2026-04-23",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.5-pro",
      "name": "gpt-5.5-pro",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.5-pro-2026-04-23",
      "name": "gpt-5.5-pro-2026-04-23",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "gpt-5.6",
      "name": "gpt-5.6",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "none",
              "label": "None"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Extra high"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-5.6-luna",
      "name": "gpt-5.6-luna",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "none",
              "label": "None"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Extra high"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-5.6-sol",
      "name": "gpt-5.6-sol",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "none",
              "label": "None"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Extra high"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-5.6-terra",
      "name": "gpt-5.6-terra",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "none",
              "label": "None"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Extra high"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-6-astra",
      "name": "gpt-6-astra",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Extra high"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-6-luna",
      "name": "gpt-6-luna",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "none",
              "label": "None"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Extra high"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-6-sol",
      "name": "gpt-6-sol",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "none",
              "label": "None"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Extra high"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "gpt-6.1-sol",
      "name": "gpt-6.1-sol",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "none",
              "label": "None"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Extra high"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 128000
    },
    {
      "api": "openai",
      "id": "o1",
      "name": "o1",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 200000
    },
    {
      "api": "openai",
      "id": "o1-2024-12-17",
      "name": "o1-2024-12-17",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 200000
    },
    {
      "api": "openai",
      "id": "o3",
      "name": "o3",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 200000
    },
    {
      "api": "openai",
      "id": "o3-2025-04-16",
      "name": "o3-2025-04-16",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 200000
    },
    {
      "api": "openai",
      "id": "o3-deep-research",
      "name": "o3-deep-research",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "o3-deep-research-2025-06-26",
      "name": "o3-deep-research-2025-06-26",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "o3-mini",
      "name": "o3-mini",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 200000
    },
    {
      "api": "openai",
      "id": "o3-mini-2025-01-31",
      "name": "o3-mini-2025-01-31",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ],
      "max_tokens": 200000
    },
    {
      "api": "openai",
      "id": "o3-pro",
      "name": "o3-pro",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "openai",
      "id": "o3-pro-2025-06-10",
      "name": "o3-pro-2025-06-10",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "minimal",
              "label": "Minimal"
            },
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            }
          ]
        },
        {
          "id": "stream",
          "key": "stream",
          "label": "Stream",
          "widget": "select",
          "options": [
            {
              "value": true,
              "label": "Stream"
            },
            {
              "value": false,
              "label": "No stream"
            }
          ]
        }
      ]
    },
    {
      "api": "opencode-go",
      "id": "iceman-contributor-free",
      "name": "Iceman Contributor Free",
      "max_tokens": 262144
    },
    {
      "api": "opencode-go",
      "id": "space-bunny",
      "name": "Space Bunny",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "muse-spark-1.2-contributor",
      "name": "Muse Spark 1.2 Contributor",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "step-5-preview-free",
      "name": "Step 5 Preview Free",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "muse-spark-1.3-contributor",
      "name": "Muse Spark 1.3 Contributor",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "hy3",
      "name": "Hy3",
      "max_tokens": 256000
    },
    {
      "api": "opencode-go",
      "id": "glm-5.2",
      "name": "GLM-5.2",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "beam-free",
      "name": "Beam Free",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "mimo-v2.5-pro",
      "name": "MiMo V2.5 Pro",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "hy4-preview",
      "name": "Hy4 preview",
      "max_tokens": 1024000
    },
    {
      "api": "opencode-go",
      "id": "qwen3.7-plus",
      "name": "Qwen3.7 Plus",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "claude-haiku-5-5",
      "name": "Claude Haiku 5.5",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "minimax-m3",
      "name": "MiniMax-M3",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "gpt-5.6-luna",
      "name": "GPT-5.6 Luna",
      "max_tokens": 1050000
    },
    {
      "api": "opencode-go",
      "id": "qwen3.8-max",
      "name": "Qwen3.8 Max",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "mimo-v2.5",
      "name": "MiMo V2.5",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "gemini-4-argon-contributor",
      "name": "Gemini 4 Argon Contributor",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "qwen3.8-flash",
      "name": "Qwen3.8 Flash",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "gemini-4-argon",
      "name": "Gemini 4 Argon",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "longcat-2.5-preview-free",
      "name": "LongCat 2.5 Preview Free",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "minimax-m2.7",
      "name": "MiniMax-M2.7",
      "max_tokens": 204800
    },
    {
      "api": "opencode-go",
      "id": "kimi-k3.1-pro",
      "name": "Kimi K3.1 Pro",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "deepseek-v4-pro",
      "name": "DeepSeek V4 Pro (New)",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "longcat-2.0",
      "name": "LongCat-2.0",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "cat-jam-free",
      "name": "Cat Jam Free",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "mimo-v2.6-pro",
      "name": "MiMo-V2.6-Pro",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "deepseek-v4.1-flash",
      "name": "DeepSeek V4.1 Flash",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "kimi-k3",
      "name": "Kimi K3",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "grok-4.7",
      "name": "Grok 4.7",
      "max_tokens": 500000
    },
    {
      "api": "opencode-go",
      "id": "minimax-m3.1-flash-free",
      "name": "MiniMax M3.1 Flash Free",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "gpt-6-luna",
      "name": "GPT-6 Luna",
      "max_tokens": 1050000
    },
    {
      "api": "opencode-go",
      "id": "mimo-v2.6-flash",
      "name": "MiMo-V2.6-Flash",
      "max_tokens": 1048576
    },
    {
      "api": "opencode-go",
      "id": "minimax-m3.1-flash",
      "name": "MiniMax M3.1 Flash",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "step-5-preview",
      "name": "Step 5 Preview",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "glm-5.3-flash",
      "name": "GLM-5.3-Flash",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "glm-5.3",
      "name": "GLM-5.3",
      "max_tokens": 1000000
    },
    {
      "api": "opencode-go",
      "id": "kimi-k2.7-code",
      "name": "Kimi K2.7 Code",
      "max_tokens": 262144
    },
    {
      "api": "openrouter",
      "id": "aion-labs/aion-2.0",
      "name": "aion-labs/aion-2.0 AionLabs: Aion-2.0",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "aion-labs/aion-3.0",
      "name": "aion-labs/aion-3.0 AionLabs: Aion-3.0",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "aion-labs/aion-3.0-mini",
      "name": "aion-labs/aion-3.0-mini AionLabs: Aion-3.0-Mini",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "aion-labs/aion-3.5",
      "name": "aion-labs/aion-3.5 AionLabs: Aion 3.5",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "aion-labs/aion-3.5-mini",
      "name": "aion-labs/aion-3.5-mini AionLabs: Aion 3.5 Mini",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "aion-labs/aion-rp-llama-3.1-8b",
      "name": "aion-labs/aion-rp-llama-3.1-8b AionLabs: Aion-RP 1.0 (8B)",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "alibaba/happyhorse-1.0",
      "name": "alibaba/happyhorse-1.0 Alibaba: HappyHorse 1.0",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "alibaba/happyhorse-1.1",
      "name": "alibaba/happyhorse-1.1 Alibaba: HappyHorse 1.1",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "alibaba/wan-2.6",
      "name": "alibaba/wan-2.6 Alibaba: Wan 2.6",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "alibaba/wan-2.7",
      "name": "alibaba/wan-2.7 Alibaba: Wan 2.7",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "alibaba/wan-3.0",
      "name": "alibaba/wan-3.0 Alibaba: Wan 3.0",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "alibaba/wan-3.0-prime",
      "name": "alibaba/wan-3.0-prime Alibaba: Wan 3.0 Prime",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "amazon/nova-2-lite-v1",
      "name": "amazon/nova-2-lite-v1 Amazon: Nova 2 Lite",
      "max_tokens": 65535
    },
    {
      "api": "openrouter",
      "id": "amazon/nova-lite-v1",
      "name": "amazon/nova-lite-v1 Amazon: Nova Lite 1.0",
      "max_tokens": 5120
    },
    {
      "api": "openrouter",
      "id": "amazon/nova-micro-v1",
      "name": "amazon/nova-micro-v1 Amazon: Nova Micro 1.0",
      "max_tokens": 5120
    },
    {
      "api": "openrouter",
      "id": "amazon/nova-premier-v1",
      "name": "amazon/nova-premier-v1 Amazon: Nova Premier 1.0",
      "max_tokens": 32000
    },
    {
      "api": "openrouter",
      "id": "amazon/nova-pro-v1",
      "name": "amazon/nova-pro-v1 Amazon: Nova Pro 1.0",
      "max_tokens": 5120
    },
    {
      "api": "openrouter",
      "id": "anthracite-org/magnum-v4-72b",
      "name": "anthracite-org/magnum-v4-72b Magnum v4 72B",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-fable-5",
      "name": "anthropic/claude-fable-5 Anthropic: Claude Fable 5",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-fable-5.1",
      "name": "anthropic/claude-fable-5.1 Anthropic: Claude Fable 5.1",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-fable-5.1:batch",
      "name": "anthropic/claude-fable-5.1:batch Anthropic: Claude Fable 5.1 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-fable-5:batch",
      "name": "anthropic/claude-fable-5:batch Anthropic: Claude Fable 5 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-haiku-4.5",
      "name": "anthropic/claude-haiku-4.5 Anthropic: Claude Haiku 4.5",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-haiku-4.5:batch",
      "name": "anthropic/claude-haiku-4.5:batch Anthropic: Claude Haiku 4.5 (batch)",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-haiku-5.5",
      "name": "anthropic/claude-haiku-5.5 Anthropic: Claude Haiku 5.5",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-haiku-5.5:batch",
      "name": "anthropic/claude-haiku-5.5:batch Anthropic: Claude Haiku 5.5 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.1",
      "name": "anthropic/claude-opus-4.1 Anthropic: Claude Opus 4.1",
      "max_tokens": 32000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.1:batch",
      "name": "anthropic/claude-opus-4.1:batch Anthropic: Claude Opus 4.1 (batch)",
      "max_tokens": 32000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.5",
      "name": "anthropic/claude-opus-4.5 Anthropic: Claude Opus 4.5",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.5:batch",
      "name": "anthropic/claude-opus-4.5:batch Anthropic: Claude Opus 4.5 (batch)",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.6",
      "name": "anthropic/claude-opus-4.6 Anthropic: Claude Opus 4.6",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.6:batch",
      "name": "anthropic/claude-opus-4.6:batch Anthropic: Claude Opus 4.6 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.7",
      "name": "anthropic/claude-opus-4.7 Anthropic: Claude Opus 4.7",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.7:batch",
      "name": "anthropic/claude-opus-4.7:batch Anthropic: Claude Opus 4.7 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.8",
      "name": "anthropic/claude-opus-4.8 Anthropic: Claude Opus 4.8",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-4.8:batch",
      "name": "anthropic/claude-opus-4.8:batch Anthropic: Claude Opus 4.8 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-5",
      "name": "anthropic/claude-opus-5 Anthropic: Claude Opus 5",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-5.5",
      "name": "anthropic/claude-opus-5.5 Anthropic: Claude Opus 5.5",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-5.5:batch",
      "name": "anthropic/claude-opus-5.5:batch Anthropic: Claude Opus 5.5 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-opus-5:batch",
      "name": "anthropic/claude-opus-5:batch Anthropic: Claude Opus 5 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-sonnet-4.5",
      "name": "anthropic/claude-sonnet-4.5 Anthropic: Claude Sonnet 4.5",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-sonnet-4.5:batch",
      "name": "anthropic/claude-sonnet-4.5:batch Anthropic: Claude Sonnet 4.5 (batch)",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-sonnet-4.6",
      "name": "anthropic/claude-sonnet-4.6 Anthropic: Claude Sonnet 4.6",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-sonnet-4.6:batch",
      "name": "anthropic/claude-sonnet-4.6:batch Anthropic: Claude Sonnet 4.6 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-sonnet-5",
      "name": "anthropic/claude-sonnet-5 Anthropic: Claude Sonnet 5",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-sonnet-5.5",
      "name": "anthropic/claude-sonnet-5.5 Anthropic: Claude Sonnet 5.5",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-sonnet-5.5:batch",
      "name": "anthropic/claude-sonnet-5.5:batch Anthropic: Claude Sonnet 5.5 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "anthropic/claude-sonnet-5:batch",
      "name": "anthropic/claude-sonnet-5:batch Anthropic: Claude Sonnet 5 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "assemblyai/universal-3-5-pro",
      "name": "assemblyai/universal-3-5-pro AssemblyAI: Universal-3.5 Pro",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "assemblyai/universal-3-6-pro",
      "name": "assemblyai/universal-3-6-pro AssemblyAI: Universal-3.6 Pro",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "baseten/elephant-1:free",
      "name": "baseten/elephant-1:free Baseten: Elephant 1 (free)",
      "max_tokens": 14745
    },
    {
      "api": "openrouter",
      "id": "baseten/mammoth-1:free",
      "name": "baseten/mammoth-1:free Baseten: Mammoth 1 (free)",
      "max_tokens": 14745
    },
    {
      "api": "openrouter",
      "id": "black-forest-labs/flux-3-image",
      "name": "black-forest-labs/flux-3-image Black Forest Labs: FLUX 3 Image",
      "max_tokens": 42177
    },
    {
      "api": "openrouter",
      "id": "black-forest-labs/flux-3-image-klein",
      "name": "black-forest-labs/flux-3-image-klein Black Forest Labs: FLUX 3 Image Klein",
      "max_tokens": 42177
    },
    {
      "api": "openrouter",
      "id": "black-forest-labs/flux-3-video",
      "name": "black-forest-labs/flux-3-video Black Forest Labs: FLUX 3 Video",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "black-forest-labs/flux-video-edit",
      "name": "black-forest-labs/flux-video-edit Black Forest Labs: FLUX Video Edit",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "black-forest-labs/flux-video-upscale",
      "name": "black-forest-labs/flux-video-upscale Black Forest Labs: FLUX Video Upscale",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "black-forest-labs/flux.2-flex",
      "name": "black-forest-labs/flux.2-flex Black Forest Labs: FLUX.2 Flex",
      "max_tokens": 60609
    },
    {
      "api": "openrouter",
      "id": "black-forest-labs/flux.2-klein-4b",
      "name": "black-forest-labs/flux.2-klein-4b Black Forest Labs: FLUX.2 Klein 4B",
      "max_tokens": 36864
    },
    {
      "api": "openrouter",
      "id": "black-forest-labs/flux.2-max",
      "name": "black-forest-labs/flux.2-max Black Forest Labs: FLUX.2 Max",
      "max_tokens": 42177
    },
    {
      "api": "openrouter",
      "id": "black-forest-labs/flux.2-pro",
      "name": "black-forest-labs/flux.2-pro Black Forest Labs: FLUX.2 Pro",
      "max_tokens": 42177
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seed-1.6",
      "name": "bytedance-seed/seed-1.6 ByteDance Seed: Seed 1.6",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seed-1.6-flash",
      "name": "bytedance-seed/seed-1.6-flash ByteDance Seed: Seed 1.6 Flash",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seed-2-1-turbo",
      "name": "bytedance-seed/seed-2-1-turbo ByteDance Seed: Seed 2.1 Turbo",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seed-2.0-code",
      "name": "bytedance-seed/seed-2.0-code ByteDance Seed: Seed-2.0-Code",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seed-2.0-lite",
      "name": "bytedance-seed/seed-2.0-lite ByteDance Seed: Seed-2.0-Lite",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seed-2.0-mini",
      "name": "bytedance-seed/seed-2.0-mini ByteDance Seed: Seed-2.0-Mini",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seed-audio-1-0",
      "name": "bytedance-seed/seed-audio-1-0 ByteDance Seed: Seed Audio 1.0",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seedream-4.5",
      "name": "bytedance-seed/seedream-4.5 ByteDance Seed: Seedream 4.5",
      "max_tokens": 3686
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seedream-5-0-flash",
      "name": "bytedance-seed/seedream-5-0-flash ByteDance Seed: Seedream 5.0 Flash",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seedream-5-0-lite",
      "name": "bytedance-seed/seedream-5-0-lite ByteDance Seed: Seedream 5.0 Lite",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "bytedance-seed/seedream-5-0-pro",
      "name": "bytedance-seed/seedream-5-0-pro ByteDance Seed: Seedream 5.0 Pro",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "bytedance/seedance-1-5-pro",
      "name": "bytedance/seedance-1-5-pro ByteDance: Seedance 1.5 Pro",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "bytedance/seedance-2.0",
      "name": "bytedance/seedance-2.0 ByteDance: Seedance 2.0",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "bytedance/seedance-2.0-fast",
      "name": "bytedance/seedance-2.0-fast ByteDance: Seedance 2.0 Fast",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "bytedance/seedance-2.0-mini",
      "name": "bytedance/seedance-2.0-mini ByteDance: Seedance 2.0 Mini",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "bytedance/seedance-2.5",
      "name": "bytedance/seedance-2.5 ByteDance: Seedance 2.5",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "bytedance/ui-tars-1.5-7b",
      "name": "bytedance/ui-tars-1.5-7b ByteDance: UI-TARS 7B ",
      "max_tokens": 2048
    },
    {
      "api": "openrouter",
      "id": "canopylabs/orpheus-3b-0.1-ft",
      "name": "canopylabs/orpheus-3b-0.1-ft Canopy Labs: Orpheus 3B",
      "max_tokens": 3686
    },
    {
      "api": "openrouter",
      "id": "cloudflare/clef",
      "name": "cloudflare/clef Cloudflare: Clef",
      "max_tokens": 14745
    },
    {
      "api": "openrouter",
      "id": "cloudflare/clef-flash",
      "name": "cloudflare/clef-flash Cloudflare: Clef Flash",
      "max_tokens": 22118
    },
    {
      "api": "openrouter",
      "id": "cloudflare/clef-omni",
      "name": "cloudflare/clef-omni Cloudflare: Clef Omni",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "cognitivecomputations/dolphin-mistral-24b-venice-edition",
      "name": "cognitivecomputations/dolphin-mistral-24b-venice-edition Venice: Uncensored",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "cohere/command-a",
      "name": "cohere/command-a Cohere: Command A",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "cohere/command-a-plus",
      "name": "cohere/command-a-plus Cohere: Command A+",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "cohere/command-r-08-2024",
      "name": "cohere/command-r-08-2024 Cohere: Command R (08-2024)",
      "max_tokens": 4000
    },
    {
      "api": "openrouter",
      "id": "cohere/command-r-plus-08-2024",
      "name": "cohere/command-r-plus-08-2024 Cohere: Command R+ (08-2024)",
      "max_tokens": 4000
    },
    {
      "api": "openrouter",
      "id": "cohere/command-r7b-12-2024",
      "name": "cohere/command-r7b-12-2024 Cohere: Command R7B (12-2024)",
      "max_tokens": 4000
    },
    {
      "api": "openrouter",
      "id": "cohere/north-mini-code:free",
      "name": "cohere/north-mini-code:free Cohere: North Mini Code (free)",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "cohere/rerank-4-fast",
      "name": "cohere/rerank-4-fast Cohere: Rerank 4 Fast",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "cohere/rerank-4-pro",
      "name": "cohere/rerank-4-pro Cohere: Rerank 4 Pro",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "cohere/rerank-v3.5",
      "name": "cohere/rerank-v3.5 Cohere: Rerank v3.5",
      "max_tokens": 3686
    },
    {
      "api": "openrouter",
      "id": "deepgram/aura-2",
      "name": "deepgram/aura-2 Deepgram: Aura-2",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "deepgram/flux-tts",
      "name": "deepgram/flux-tts Deepgram: Flux TTS",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "deepgram/nova-3",
      "name": "deepgram/nova-3 Deepgram: Nova-3",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-chat",
      "name": "deepseek/deepseek-chat DeepSeek: DeepSeek V3",
      "max_tokens": 16000
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-chat-v3-0324",
      "name": "deepseek/deepseek-chat-v3-0324 DeepSeek: DeepSeek V3 0324",
      "max_tokens": 115200
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-chat-v3.1",
      "name": "deepseek/deepseek-chat-v3.1 DeepSeek: DeepSeek V3.1",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-r1-0528",
      "name": "deepseek/deepseek-r1-0528 DeepSeek: R1 0528",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v3.1-terminus",
      "name": "deepseek/deepseek-v3.1-terminus DeepSeek: DeepSeek V3.1 Terminus",
      "max_tokens": 147456
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v3.2",
      "name": "deepseek/deepseek-v3.2 DeepSeek: DeepSeek V3.2",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v3.2-exp",
      "name": "deepseek/deepseek-v3.2-exp DeepSeek: DeepSeek V3.2 Exp",
      "max_tokens": 147456
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v4-flash",
      "name": "deepseek/deepseek-v4-flash DeepSeek: DeepSeek V4 Flash 0423",
      "max_tokens": 943717
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v4-flash-0731",
      "name": "deepseek/deepseek-v4-flash-0731 DeepSeek: DeepSeek V4 Flash 0731",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v4-flash-vision-exp",
      "name": "deepseek/deepseek-v4-flash-vision-exp DeepSeek: DeepSeek V4 Flash Vision Exp",
      "max_tokens": 262144
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v4-pro",
      "name": "deepseek/deepseek-v4-pro DeepSeek: DeepSeek V4 Pro 0423",
      "max_tokens": 384000
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v4-pro-0813",
      "name": "deepseek/deepseek-v4-pro-0813 DeepSeek: DeepSeek V4 Pro 0813",
      "max_tokens": 393216
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v4.1-flash",
      "name": "deepseek/deepseek-v4.1-flash DeepSeek: DeepSeek V4.1 Flash",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v4.1-flash-1017",
      "name": "deepseek/deepseek-v4.1-flash-1017 DeepSeek: DeepSeek V4.1 Flash 1017",
      "max_tokens": 393216
    },
    {
      "api": "openrouter",
      "id": "deepseek/deepseek-v4.1-flash:batch",
      "name": "deepseek/deepseek-v4.1-flash:batch DeepSeek: DeepSeek V4.1 Flash (batch)",
      "max_tokens": 384000
    },
    {
      "api": "openrouter",
      "id": "dots-studio/dots-3-note-preview:free",
      "name": "dots-studio/dots-3-note-preview:free Dots Studio: Dots3-Note Preview (free)",
      "max_tokens": 460800
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/eleven-flash-v2",
      "name": "elevenlabs/eleven-flash-v2 ElevenLabs: Eleven Flash v2",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/eleven-flash-v2.5",
      "name": "elevenlabs/eleven-flash-v2.5 ElevenLabs: Eleven Flash v2.5",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/eleven-multilingual-v2",
      "name": "elevenlabs/eleven-multilingual-v2 ElevenLabs: Eleven Multilingual v2",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/eleven-turbo-v2",
      "name": "elevenlabs/eleven-turbo-v2 ElevenLabs: Eleven Turbo v2",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/eleven-turbo-v2.5",
      "name": "elevenlabs/eleven-turbo-v2.5 ElevenLabs: Eleven Turbo v2.5",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/eleven-v3",
      "name": "elevenlabs/eleven-v3 ElevenLabs: Eleven v3",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/eleven-v3-conversational",
      "name": "elevenlabs/eleven-v3-conversational ElevenLabs: Eleven v3 Conversational",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/eleven-v4",
      "name": "elevenlabs/eleven-v4 ElevenLabs: Eleven v4",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/eleven-v4-turbo",
      "name": "elevenlabs/eleven-v4-turbo ElevenLabs: Eleven v4 Turbo",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/scribe-v2",
      "name": "elevenlabs/scribe-v2 ElevenLabs: Scribe v2",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elevenlabs/scribe-v2-medical",
      "name": "elevenlabs/scribe-v2-medical ElevenLabs: Scribe v2 Medical",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "elorian/glimpse",
      "name": "elorian/glimpse Elorian: Glimpse",
      "max_tokens": 256000
    },
    {
      "api": "openrouter",
      "id": "fireworks/ember-1",
      "name": "fireworks/ember-1 Fireworks: Ember-1",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "fish-audio/drama-3",
      "name": "fish-audio/drama-3 Fish Audio: Drama 3",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "fish-audio/s1",
      "name": "fish-audio/s1 Fish Audio: S1",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "fish-audio/s2-pro",
      "name": "fish-audio/s2-pro Fish Audio: S2 Pro",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "fish-audio/s2.1-pro",
      "name": "fish-audio/s2.1-pro Fish Audio: S2.1 Pro",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "fish-audio/s2.1-pro-free:free",
      "name": "fish-audio/s2.1-pro-free:free Fish Audio: S2.1 Pro Free (free)",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "fish-audio/transcribe-1",
      "name": "fish-audio/transcribe-1 Fish Audio: Transcribe 1",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "fish-audio/transcribe-1-pro",
      "name": "fish-audio/transcribe-1-pro Fish Audio: Transcribe 1 Pro",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "google/chirp-3",
      "name": "google/chirp-3 Google: Chirp 3",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "google/gemini-2.5-flash",
      "name": "google/gemini-2.5-flash Google: Gemini 2.5 Flash",
      "max_tokens": 65535
    },
    {
      "api": "openrouter",
      "id": "google/gemini-2.5-flash-image",
      "name": "google/gemini-2.5-flash-image Google: Nano Banana (Gemini 2.5 Flash Image)",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "google/gemini-2.5-flash-lite",
      "name": "google/gemini-2.5-flash-lite Google: Gemini 2.5 Flash Lite",
      "max_tokens": 65535
    },
    {
      "api": "openrouter",
      "id": "google/gemini-2.5-pro",
      "name": "google/gemini-2.5-pro Google: Gemini 2.5 Pro",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-2.5-pro-preview",
      "name": "google/gemini-2.5-pro-preview Google: Gemini 2.5 Pro Preview 06-05",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3-flash-preview",
      "name": "google/gemini-3-flash-preview Google: Gemini 3 Flash Preview",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3-flash-preview:batch",
      "name": "google/gemini-3-flash-preview:batch Google: Gemini 3 Flash Preview (batch)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3-pro-image",
      "name": "google/gemini-3-pro-image Google: Nano Banana Pro (Gemini 3 Pro Image)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3-pro-image-preview",
      "name": "google/gemini-3-pro-image-preview Google: Nano Banana Pro (Gemini 3 Pro Image Preview)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-flash-image",
      "name": "google/gemini-3.1-flash-image Google: Nano Banana 2 (Gemini 3.1 Flash Image)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-flash-image-preview",
      "name": "google/gemini-3.1-flash-image-preview Google: Nano Banana 2 (Gemini 3.1 Flash Image Preview)",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-flash-lite",
      "name": "google/gemini-3.1-flash-lite Google: Gemini 3.1 Flash Lite",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-flash-lite-image",
      "name": "google/gemini-3.1-flash-lite-image Google: Nano Banana 2 Lite (Gemini 3.1 Flash Lite Image)",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-flash-lite-preview",
      "name": "google/gemini-3.1-flash-lite-preview Google: Gemini 3.1 Flash Lite Preview",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-flash-lite:batch",
      "name": "google/gemini-3.1-flash-lite:batch Google: Gemini 3.1 Flash Lite (batch)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-flash-tts-preview",
      "name": "google/gemini-3.1-flash-tts-preview Google: Gemini 3.1 Flash TTS Preview",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-pro-preview",
      "name": "google/gemini-3.1-pro-preview Google: Gemini 3.1 Pro Preview",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-pro-preview-customtools",
      "name": "google/gemini-3.1-pro-preview-customtools Google: Gemini 3.1 Pro Preview Custom Tools",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.1-pro-preview:batch",
      "name": "google/gemini-3.1-pro-preview:batch Google: Gemini 3.1 Pro Preview (batch)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.5-flash",
      "name": "google/gemini-3.5-flash Google: Gemini 3.5 Flash",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.5-flash-lite",
      "name": "google/gemini-3.5-flash-lite Google: Gemini 3.5 Flash Lite",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.5-flash-lite:batch",
      "name": "google/gemini-3.5-flash-lite:batch Google: Gemini 3.5 Flash Lite (batch)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.5-flash:batch",
      "name": "google/gemini-3.5-flash:batch Google: Gemini 3.5 Flash (batch)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.5-transcribe",
      "name": "google/gemini-3.5-transcribe Google: Gemini 3.5 Transcribe",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.6-flash",
      "name": "google/gemini-3.6-flash Google: Gemini 3.6 Flash",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.6-flash:batch",
      "name": "google/gemini-3.6-flash:batch Google: Gemini 3.6 Flash (batch)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.7-flash",
      "name": "google/gemini-3.7-flash Google: Gemini 3.7 Flash",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.7-flash:batch",
      "name": "google/gemini-3.7-flash:batch Google: Gemini 3.7 Flash (batch)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.8-flash",
      "name": "google/gemini-3.8-flash Google: Gemini 3.8 Flash",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.8-flash-lite-tts",
      "name": "google/gemini-3.8-flash-lite-tts Google: Gemini 3.8 Flash Lite TTS",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.8-flash-tts",
      "name": "google/gemini-3.8-flash-tts Google: Gemini 3.8 Flash TTS",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "google/gemini-3.8-flash:batch",
      "name": "google/gemini-3.8-flash:batch Google: Gemini 3.8 Flash (batch)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/gemini-4-argon",
      "name": "google/gemini-4-argon Google: Gemini 4 Argon",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "google/gemini-4-argon:batch",
      "name": "google/gemini-4-argon:batch Google: Gemini 4 Argon (batch)",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "google/gemini-nano-banana-2.1",
      "name": "google/gemini-nano-banana-2.1 Google: Nano Banana 2.1",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "google/gemma-2-27b-it",
      "name": "google/gemma-2-27b-it Google: Gemma 2 27B",
      "max_tokens": 2048
    },
    {
      "api": "openrouter",
      "id": "google/gemma-3-12b-it",
      "name": "google/gemma-3-12b-it Google: Gemma 3 12B",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "google/gemma-3-27b-it",
      "name": "google/gemma-3-27b-it Google: Gemma 3 27B",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "google/gemma-3-4b-it",
      "name": "google/gemma-3-4b-it Google: Gemma 3 4B",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "google/gemma-4-26b-a4b-it",
      "name": "google/gemma-4-26b-a4b-it Google: Gemma 4 26B A4B ",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "google/gemma-4-26b-a4b-it:free",
      "name": "google/gemma-4-26b-a4b-it:free Google: Gemma 4 26B A4B  (free)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "google/gemma-4-31b-it",
      "name": "google/gemma-4-31b-it Google: Gemma 4 31B",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "google/gemma-4-31b-it:free",
      "name": "google/gemma-4-31b-it:free Google: Gemma 4 31B (free)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "google/lyria-3-clip-preview",
      "name": "google/lyria-3-clip-preview Google: Lyria 3 Clip Preview",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/lyria-3-pro-preview",
      "name": "google/lyria-3-pro-preview Google: Lyria 3 Pro Preview",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "google/veo-3.1",
      "name": "google/veo-3.1 Google: Veo 3.1",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "google/veo-3.1-fast",
      "name": "google/veo-3.1-fast Google: Veo 3.1 Fast",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "google/veo-3.1-lite",
      "name": "google/veo-3.1-lite Google: Veo 3.1 Lite",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "gryphe/mythomax-l2-13b",
      "name": "gryphe/mythomax-l2-13b MythoMax 13B",
      "max_tokens": 3686
    },
    {
      "api": "openrouter",
      "id": "hexgrad/kokoro-82m",
      "name": "hexgrad/kokoro-82m hexgrad: Kokoro 82M",
      "max_tokens": 3686
    },
    {
      "api": "openrouter",
      "id": "heygen/avatar-iv",
      "name": "heygen/avatar-iv HeyGen: Avatar IV",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "heygen/heygen-video-1",
      "name": "heygen/heygen-video-1 HeyGen: HeyGen Video",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "heygen/heygen-voice-1",
      "name": "heygen/heygen-voice-1 HeyGen: HeyGen Voice",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "heygen/heygen-voice-1-turbo",
      "name": "heygen/heygen-voice-1-turbo HeyGen: HeyGen Voice Turbo",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "heygen/heygen-voice-1-turbo:free",
      "name": "heygen/heygen-voice-1-turbo:free HeyGen: HeyGen Voice Turbo (free)",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "ibm-granite/granite-4.0-h-micro",
      "name": "ibm-granite/granite-4.0-h-micro IBM: Granite 4.0 Micro",
      "max_tokens": 117900
    },
    {
      "api": "openrouter",
      "id": "ibm-granite/granite-4.2-8b",
      "name": "ibm-granite/granite-4.2-8b IBM: Granite 4.2 8B",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "inception/mercury-2",
      "name": "inception/mercury-2 Inception: Mercury 2",
      "max_tokens": 50000
    },
    {
      "api": "openrouter",
      "id": "inception/mercury-2.5",
      "name": "inception/mercury-2.5 Inception: Mercury 2.5",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "inception/mercury-3",
      "name": "inception/mercury-3 Inception: Mercury 3",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "inception/mercury-decide",
      "name": "inception/mercury-decide Inception: Mercury Decide",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "inception/mercury-decide:free",
      "name": "inception/mercury-decide:free Inception: Mercury Decide (free)",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "inclusionai/ling-3.0-flash",
      "name": "inclusionai/ling-3.0-flash inclusionAI: Ling 3.0 Flash",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "inclusionai/ling-3.0-flash-vl",
      "name": "inclusionai/ling-3.0-flash-vl inclusionAI: Ling 3.0 Flash VL",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "inclusionai/ling-3.1-flash",
      "name": "inclusionai/ling-3.1-flash inclusionAI: Ling 3.1 Flash",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "inference-net/schematron-v2-small",
      "name": "inference-net/schematron-v2-small Inference.net: Schematron V2 Small",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "inference-net/schematron-v2-turbo",
      "name": "inference-net/schematron-v2-turbo Inference.net: Schematron V2 Turbo",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "jaredpalmer/kev-4b",
      "name": "jaredpalmer/kev-4b Jared Palmer: Kev 4B",
      "max_tokens": 7372
    },
    {
      "api": "openrouter",
      "id": "krea/k3-edit",
      "name": "krea/k3-edit Krea: K3 Edit",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "krea/krea-2-large",
      "name": "krea/krea-2-large Krea: Krea 2 Large",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "krea/krea-2-medium",
      "name": "krea/krea-2-medium Krea: Krea 2 Medium",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "krea/krea-2-medium-turbo",
      "name": "krea/krea-2-medium-turbo Krea: Krea 2 Medium Turbo",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "kwaivgi/kling-v3.0-pro",
      "name": "kwaivgi/kling-v3.0-pro Kling: Video v3.0 Pro",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "kwaivgi/kling-v3.0-std",
      "name": "kwaivgi/kling-v3.0-std Kling: Video v3.0 Standard",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "kwaivgi/kling-video-o1",
      "name": "kwaivgi/kling-video-o1 Kling: Video O1",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "liquid/d1",
      "name": "liquid/d1 LiquidAI: d1",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "liquid/d1-ultra",
      "name": "liquid/d1-ultra LiquidAI: d1-ultra",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "liquid/lfm-2.5-2.6b",
      "name": "liquid/lfm-2.5-2.6b LiquidAI: LFM2.5-2.6B",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "liquid/lfm-2.5-2.6b:free",
      "name": "liquid/lfm-2.5-2.6b:free LiquidAI: LFM2.5-2.6B (free)",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "liquid/lfm-2.5-24b-a2b",
      "name": "liquid/lfm-2.5-24b-a2b LiquidAI: LFM2.5-24B-A2B",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "mancer/weaver",
      "name": "mancer/weaver Mancer: Weaver (alpha)",
      "max_tokens": 6000
    },
    {
      "api": "openrouter",
      "id": "meituan/longcat-2.0",
      "name": "meituan/longcat-2.0 Meituan: LongCat 2.0",
      "max_tokens": 262144
    },
    {
      "api": "openrouter",
      "id": "meta-llama/llama-3.1-70b-instruct",
      "name": "meta-llama/llama-3.1-70b-instruct Meta: Llama 3.1 70B Instruct",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "meta-llama/llama-3.1-8b-instruct",
      "name": "meta-llama/llama-3.1-8b-instruct Meta: Llama 3.1 8B Instruct",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "meta-llama/llama-3.2-1b-instruct",
      "name": "meta-llama/llama-3.2-1b-instruct Meta: Llama 3.2 1B Instruct",
      "max_tokens": 54000
    },
    {
      "api": "openrouter",
      "id": "meta-llama/llama-3.2-3b-instruct",
      "name": "meta-llama/llama-3.2-3b-instruct Meta: Llama 3.2 3B Instruct",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "meta-llama/llama-3.3-70b-instruct",
      "name": "meta-llama/llama-3.3-70b-instruct Meta: Llama 3.3 70B Instruct",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "meta-llama/llama-4-maverick",
      "name": "meta-llama/llama-4-maverick Meta: Llama 4 Maverick",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "meta-llama/llama-4-scout",
      "name": "meta-llama/llama-4-scout Meta: Llama 4 Scout",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "meta-llama/llama-guard-4-12b",
      "name": "meta-llama/llama-guard-4-12b Meta: Llama Guard 4 12B",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "meta/muse-glimmer-30b",
      "name": "meta/muse-glimmer-30b Meta: Muse Glimmer 30B",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "meta/muse-image",
      "name": "meta/muse-image Meta: Muse Image",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "meta/muse-spark-1.1",
      "name": "meta/muse-spark-1.1 Meta: Muse Spark 1.1",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "meta/muse-spark-1.2",
      "name": "meta/muse-spark-1.2 Meta: Muse Spark 1.2",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "meta/muse-spark-1.2-contributor",
      "name": "meta/muse-spark-1.2-contributor Meta: Muse Spark 1.2 Contributor",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "meta/muse-spark-1.3",
      "name": "meta/muse-spark-1.3 Meta: Muse Spark 1.3",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "meta/muse-spark-1.3-contributor",
      "name": "meta/muse-spark-1.3-contributor Meta: Muse Spark 1.3 Contributor",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "meta/muse-spark-open",
      "name": "meta/muse-spark-open Meta: Muse Spark Open",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "meta/muse-voice-transcribe-1.0",
      "name": "meta/muse-voice-transcribe-1.0 Meta: Muse Voice Transcribe 1.0",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "meta/muse-wonder",
      "name": "meta/muse-wonder Meta: Muse Wonder",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-image-2.5",
      "name": "microsoft/mai-image-2.5 Microsoft AI: MAI-Image-2.5",
      "max_tokens": 1024
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-image-2.5-pro",
      "name": "microsoft/mai-image-2.5-pro Microsoft AI: MAI-Image-2.5 Pro",
      "max_tokens": 1024
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-image-2.6",
      "name": "microsoft/mai-image-2.6 Microsoft AI: MAI-Image-2.6",
      "max_tokens": 1024
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-image-2.6-flash",
      "name": "microsoft/mai-image-2.6-flash Microsoft AI: MAI-Image-2.6 Flash",
      "max_tokens": 1024
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-transcribe-1.5",
      "name": "microsoft/mai-transcribe-1.5 Microsoft AI: MAI-Transcribe 1.5",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-transcribe-2",
      "name": "microsoft/mai-transcribe-2 Microsoft AI: MAI-Transcribe 2",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-voice-2",
      "name": "microsoft/mai-voice-2 Microsoft AI: MAI-Voice-2",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-voice-2-flash",
      "name": "microsoft/mai-voice-2-flash Microsoft AI: MAI-Voice-2-Flash",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-voice-2.1",
      "name": "microsoft/mai-voice-2.1 Microsoft AI: MAI-Voice-2.1",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "microsoft/mai-voice-2.1-flash",
      "name": "microsoft/mai-voice-2.1-flash Microsoft AI: MAI-Voice-2.1-Flash",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "microsoft/microsoft-decision-1",
      "name": "microsoft/microsoft-decision-1 Microsoft: Microsoft-Decision-1",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "microsoft/phi-4",
      "name": "microsoft/phi-4 Microsoft: Phi 4",
      "max_tokens": 14745
    },
    {
      "api": "openrouter",
      "id": "minimax/hailuo-2.3",
      "name": "minimax/hailuo-2.3 MiniMax: Hailuo 2.3",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "minimax/hailuo-3",
      "name": "minimax/hailuo-3 MiniMax: H3",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "minimax/hailuo-3-max",
      "name": "minimax/hailuo-3-max MiniMax: H3 Max",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "minimax/minimax-01",
      "name": "minimax/minimax-01 MiniMax: MiniMax-01",
      "max_tokens": 900172
    },
    {
      "api": "openrouter",
      "id": "minimax/minimax-m1",
      "name": "minimax/minimax-m1 MiniMax: MiniMax M1",
      "max_tokens": 40000
    },
    {
      "api": "openrouter",
      "id": "minimax/minimax-m2",
      "name": "minimax/minimax-m2 MiniMax: MiniMax M2",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "minimax/minimax-m2-her",
      "name": "minimax/minimax-m2-her MiniMax: MiniMax M2-her",
      "max_tokens": 2048
    },
    {
      "api": "openrouter",
      "id": "minimax/minimax-m2.1",
      "name": "minimax/minimax-m2.1 MiniMax: MiniMax M2.1",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "minimax/minimax-m2.5",
      "name": "minimax/minimax-m2.5 MiniMax: MiniMax M2.5",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "minimax/minimax-m2.7",
      "name": "minimax/minimax-m2.7 MiniMax: MiniMax M2.7",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "minimax/minimax-m3",
      "name": "minimax/minimax-m3 MiniMax: MiniMax M3",
      "max_tokens": 512000
    },
    {
      "api": "openrouter",
      "id": "minimax/minimax-m3.1-flash",
      "name": "minimax/minimax-m3.1-flash MiniMax: MiniMax M3.1 Flash",
      "max_tokens": 524288
    },
    {
      "api": "openrouter",
      "id": "minimax/speech-2.8-hd",
      "name": "minimax/speech-2.8-hd MiniMax: Speech 2.8 HD",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "minimax/speech-2.8-turbo",
      "name": "minimax/speech-2.8-turbo MiniMax: Speech 2.8 Turbo",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "mistralai/codestral-2508",
      "name": "mistralai/codestral-2508 Mistral: Codestral 2508",
      "max_tokens": 204800
    },
    {
      "api": "openrouter",
      "id": "mistralai/codestral-2508:batch",
      "name": "mistralai/codestral-2508:batch Mistral: Codestral 2508 (batch)",
      "max_tokens": 204800
    },
    {
      "api": "openrouter",
      "id": "mistralai/devstral-2512",
      "name": "mistralai/devstral-2512 Mistral: Devstral 2 2512",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/ministral-14b-2512",
      "name": "mistralai/ministral-14b-2512 Mistral: Ministral 3 14B 2512",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/ministral-3b-2512",
      "name": "mistralai/ministral-3b-2512 Mistral: Ministral 3 3B 2512",
      "max_tokens": 104857
    },
    {
      "api": "openrouter",
      "id": "mistralai/ministral-8b-2512",
      "name": "mistralai/ministral-8b-2512 Mistral: Ministral 3 8B 2512",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/ministral-8b-2512:batch",
      "name": "mistralai/ministral-8b-2512:batch Mistral: Ministral 3 8B 2512 (batch)",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-large",
      "name": "mistralai/mistral-large Mistral Large",
      "max_tokens": 102400
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-large-2407",
      "name": "mistralai/mistral-large-2407 Mistral Large 2407",
      "max_tokens": 104857
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-large-2512",
      "name": "mistralai/mistral-large-2512 Mistral: Mistral Large 3 2512",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-large-2512:batch",
      "name": "mistralai/mistral-large-2512:batch Mistral: Mistral Large 3 2512 (batch)",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-large-4-0",
      "name": "mistralai/mistral-large-4-0 Mistral: Mistral Large 4",
      "max_tokens": 262144
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-medium-3",
      "name": "mistralai/mistral-medium-3 Mistral: Mistral Medium 3",
      "max_tokens": 104857
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-medium-3-5",
      "name": "mistralai/mistral-medium-3-5 Mistral: Mistral Medium 3.5",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-medium-3-5:batch",
      "name": "mistralai/mistral-medium-3-5:batch Mistral: Mistral Medium 3.5 (batch)",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-medium-3.1",
      "name": "mistralai/mistral-medium-3.1 Mistral: Mistral Medium 3.1",
      "max_tokens": 104857
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-medium-3.1:batch",
      "name": "mistralai/mistral-medium-3.1:batch Mistral: Mistral Medium 3.1 (batch)",
      "max_tokens": 104857
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-nemo",
      "name": "mistralai/mistral-nemo Mistral: Mistral Nemo",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-saba",
      "name": "mistralai/mistral-saba Mistral: Saba",
      "max_tokens": 26214
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-small-24b-instruct-2501",
      "name": "mistralai/mistral-small-24b-instruct-2501 Mistral: Mistral Small 3",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-small-2603",
      "name": "mistralai/mistral-small-2603 Mistral: Mistral Small 4",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-small-2603:batch",
      "name": "mistralai/mistral-small-2603:batch Mistral: Mistral Small 4 (batch)",
      "max_tokens": 209715
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-small-3.1-24b-instruct",
      "name": "mistralai/mistral-small-3.1-24b-instruct Mistral: Mistral Small 3.1 24B",
      "max_tokens": 102400
    },
    {
      "api": "openrouter",
      "id": "mistralai/mistral-small-3.2-24b-instruct",
      "name": "mistralai/mistral-small-3.2-24b-instruct Mistral: Mistral Small 3.2 24B",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "mistralai/mixtral-8x22b-instruct",
      "name": "mistralai/mixtral-8x22b-instruct Mistral: Mixtral 8x22B Instruct",
      "max_tokens": 52428
    },
    {
      "api": "openrouter",
      "id": "mistralai/voxtral-mini-3b-2507",
      "name": "mistralai/voxtral-mini-3b-2507 Mistral: Voxtral Mini 3B 2507",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "mistralai/voxtral-mini-transcribe",
      "name": "mistralai/voxtral-mini-transcribe Mistral: Voxtral Mini Transcribe",
      "max_tokens": 13107
    },
    {
      "api": "openrouter",
      "id": "mistralai/voxtral-mini-transcribe-3-0",
      "name": "mistralai/voxtral-mini-transcribe-3-0 Mistral: Voxtral Mini Transcribe 3",
      "max_tokens": 52428
    },
    {
      "api": "openrouter",
      "id": "mistralai/voxtral-mini-tts-2603",
      "name": "mistralai/voxtral-mini-tts-2603 Mistral: Voxtral Mini TTS",
      "max_tokens": 3276
    },
    {
      "api": "openrouter",
      "id": "mistralai/voxtral-mini-tts-3-0",
      "name": "mistralai/voxtral-mini-tts-3-0 Mistral: Voxtral TTS 3",
      "max_tokens": 3276
    },
    {
      "api": "openrouter",
      "id": "mistralai/voxtral-small-24b-2507",
      "name": "mistralai/voxtral-small-24b-2507 Mistral: Voxtral Small 24B 2507",
      "max_tokens": 26214
    },
    {
      "api": "openrouter",
      "id": "mistralai/voxtral-small-24b-2507-stt",
      "name": "mistralai/voxtral-small-24b-2507-stt Mistral: Voxtral Small 24B 2507 STT",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "mistralai/voxtral-small-transcribe-3-0",
      "name": "mistralai/voxtral-small-transcribe-3-0 Mistral: Voxtral Small Transcribe 3",
      "max_tokens": 52428
    },
    {
      "api": "openrouter",
      "id": "moondream/moondream3-preview",
      "name": "moondream/moondream3-preview Moondream: Moondream 3 Preview",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "moondream/moondream3.1-9b-a2b",
      "name": "moondream/moondream3.1-9b-a2b Moondream: Moondream 3.1",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "moonshotai/kimi-k2",
      "name": "moonshotai/kimi-k2 MoonshotAI: Kimi K2 0711",
      "max_tokens": 98304
    },
    {
      "api": "openrouter",
      "id": "moonshotai/kimi-k2-0905",
      "name": "moonshotai/kimi-k2-0905 MoonshotAI: Kimi K2 0905",
      "max_tokens": 98304
    },
    {
      "api": "openrouter",
      "id": "moonshotai/kimi-k2-thinking",
      "name": "moonshotai/kimi-k2-thinking MoonshotAI: Kimi K2 Thinking",
      "max_tokens": 98304
    },
    {
      "api": "openrouter",
      "id": "moonshotai/kimi-k2.5",
      "name": "moonshotai/kimi-k2.5 MoonshotAI: Kimi K2.5",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "moonshotai/kimi-k2.6",
      "name": "moonshotai/kimi-k2.6 MoonshotAI: Kimi K2.6",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "moonshotai/kimi-k2.7-code",
      "name": "moonshotai/kimi-k2.7-code MoonshotAI: Kimi K2.7 Code",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "moonshotai/kimi-k3",
      "name": "moonshotai/kimi-k3 MoonshotAI: Kimi K3",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "moonshotai/kimi-k3.1-pro",
      "name": "moonshotai/kimi-k3.1-pro MoonshotAI: Kimi K3.1 Pro",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "moonshotai/kimi-k3:batch",
      "name": "moonshotai/kimi-k3:batch MoonshotAI: Kimi K3 (batch)",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "morph/morph-v3-fast",
      "name": "morph/morph-v3-fast Morph: Morph V3 Fast",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "morph/morph-v3-large",
      "name": "morph/morph-v3-large Morph: Morph V3 Large",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "nace-ai/drex-max",
      "name": "nace-ai/drex-max Nace.AI: Drex Max",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "nace-ai/drex-v1.5",
      "name": "nace-ai/drex-v1.5 Nace.AI: Drex v1.5",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "nace-ai/drex-v2.0",
      "name": "nace-ai/drex-v2.0 Nace.AI: Drex v2.0",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "nex-agi/nex-n2.5-mini",
      "name": "nex-agi/nex-n2.5-mini Nex AGI: Nex-N2.5-Mini",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "nex-agi/nex-n2.5-pro",
      "name": "nex-agi/nex-n2.5-pro Nex AGI: Nex-N2.5-Pro",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "nousresearch/hermes-3-llama-3.1-405b",
      "name": "nousresearch/hermes-3-llama-3.1-405b Nous: Hermes 3 405B Instruct",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "nousresearch/hermes-3-llama-3.1-70b",
      "name": "nousresearch/hermes-3-llama-3.1-70b Nous: Hermes 3 70B Instruct",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "nousresearch/hermes-4-405b",
      "name": "nousresearch/hermes-4-405b Nous: Hermes 4 405B",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "nvidia/llama-nemotron-rerank-vl-1b-v2:free",
      "name": "nvidia/llama-nemotron-rerank-vl-1b-v2:free NVIDIA: Llama Nemotron Rerank VL 1B V2 (free)",
      "max_tokens": 9216
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3-nano-30b-a3b",
      "name": "nvidia/nemotron-3-nano-30b-a3b NVIDIA: Nemotron 3 Nano 30B A3B",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free",
      "name": "nvidia/nemotron-3-nano-omni-30b-a3b-reasoning:free NVIDIA: Nemotron 3 Nano Omni (free)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3-super-120b-a12b",
      "name": "nvidia/nemotron-3-super-120b-a12b NVIDIA: Nemotron 3 Super",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3-super-120b-a12b:free",
      "name": "nvidia/nemotron-3-super-120b-a12b:free NVIDIA: Nemotron 3 Super (free)",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3-ultra-550b-a55b",
      "name": "nvidia/nemotron-3-ultra-550b-a55b NVIDIA: Nemotron 3 Ultra",
      "max_tokens": 182520
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3-ultra-550b-a55b:free",
      "name": "nvidia/nemotron-3-ultra-550b-a55b:free NVIDIA: Nemotron 3 Ultra (free)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3.5-asr-streaming-multilingual-0.6b",
      "name": "nvidia/nemotron-3.5-asr-streaming-multilingual-0.6b NVIDIA: Nemotron 3.5 ASR Streaming Multilingual 0.6B",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3.5-content-safety",
      "name": "nvidia/nemotron-3.5-content-safety NVIDIA: Nemotron 3.5 Content Safety",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3.5-content-safety:free",
      "name": "nvidia/nemotron-3.5-content-safety:free NVIDIA: Nemotron 3.5 Content Safety (free)",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3.5-lightning",
      "name": "nvidia/nemotron-3.5-lightning NVIDIA: Nemotron 3.5 Lightning",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3.5-lightning:free",
      "name": "nvidia/nemotron-3.5-lightning:free NVIDIA: Nemotron 3.5 Lightning (free)",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3.5-rerank-8b:free",
      "name": "nvidia/nemotron-3.5-rerank-8b:free NVIDIA: Nemotron 3.5 Rerank 8B (free)",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3.5-super-vl",
      "name": "nvidia/nemotron-3.5-super-vl NVIDIA: Nemotron 3.5 Super VL",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "nvidia/nemotron-3.5-super-vl:free",
      "name": "nvidia/nemotron-3.5-super-vl:free NVIDIA: Nemotron 3.5 Super VL (free)",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "nvidia/parakeet-tdt-0.6b-v3",
      "name": "nvidia/parakeet-tdt-0.6b-v3 NVIDIA: Parakeet TDT 0.6B v3",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "nvidia/switchyard",
      "name": "nvidia/switchyard NVIDIA: Switchyard"
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-3.5-turbo-0613",
      "name": "openai/gpt-3.5-turbo-0613 OpenAI: GPT-3.5 Turbo (older v0613)",
      "max_tokens": 3685
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-3.5-turbo-16k",
      "name": "openai/gpt-3.5-turbo-16k OpenAI: GPT-3.5 Turbo 16k",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4",
      "name": "openai/gpt-4 OpenAI: GPT-4",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4-turbo",
      "name": "openai/gpt-4-turbo OpenAI: GPT-4 Turbo",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4-turbo:batch",
      "name": "openai/gpt-4-turbo:batch OpenAI: GPT-4 Turbo (batch)",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4.1",
      "name": "openai/gpt-4.1 OpenAI: GPT-4.1",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4.1-mini",
      "name": "openai/gpt-4.1-mini OpenAI: GPT-4.1 Mini",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4.1-mini:batch",
      "name": "openai/gpt-4.1-mini:batch OpenAI: GPT-4.1 Mini (batch)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4.1-nano",
      "name": "openai/gpt-4.1-nano OpenAI: GPT-4.1 Nano",
      "max_tokens": 942818
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4.1-nano:batch",
      "name": "openai/gpt-4.1-nano:batch OpenAI: GPT-4.1 Nano (batch)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4.1:batch",
      "name": "openai/gpt-4.1:batch OpenAI: GPT-4.1 (batch)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o",
      "name": "openai/gpt-4o OpenAI: GPT-4o",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o-2024-05-13",
      "name": "openai/gpt-4o-2024-05-13 OpenAI: GPT-4o (2024-05-13)",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o-2024-08-06",
      "name": "openai/gpt-4o-2024-08-06 OpenAI: GPT-4o (2024-08-06)",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o-2024-11-20",
      "name": "openai/gpt-4o-2024-11-20 OpenAI: GPT-4o (2024-11-20)",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o-mini",
      "name": "openai/gpt-4o-mini OpenAI: GPT-4o-mini",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o-mini-2024-07-18",
      "name": "openai/gpt-4o-mini-2024-07-18 OpenAI: GPT-4o-mini (2024-07-18)",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o-mini-transcribe",
      "name": "openai/gpt-4o-mini-transcribe OpenAI: GPT-4o Mini Transcribe",
      "max_tokens": 115200
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o-mini:batch",
      "name": "openai/gpt-4o-mini:batch OpenAI: GPT-4o-mini (batch)",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o-transcribe",
      "name": "openai/gpt-4o-transcribe OpenAI: GPT-4o Transcribe",
      "max_tokens": 115200
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-4o:batch",
      "name": "openai/gpt-4o:batch OpenAI: GPT-4o (batch)",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5",
      "name": "openai/gpt-5 OpenAI: GPT-5",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5-image",
      "name": "openai/gpt-5-image OpenAI: GPT-5 Image",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5-image-mini",
      "name": "openai/gpt-5-image-mini OpenAI: GPT-5 Image Mini",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5-mini",
      "name": "openai/gpt-5-mini OpenAI: GPT-5 Mini",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5-mini:batch",
      "name": "openai/gpt-5-mini:batch OpenAI: GPT-5 Mini (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5-nano",
      "name": "openai/gpt-5-nano OpenAI: GPT-5 Nano",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5-nano:batch",
      "name": "openai/gpt-5-nano:batch OpenAI: GPT-5 Nano (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5-pro",
      "name": "openai/gpt-5-pro OpenAI: GPT-5 Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5-pro:batch",
      "name": "openai/gpt-5-pro:batch OpenAI: GPT-5 Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.1",
      "name": "openai/gpt-5.1 OpenAI: GPT-5.1",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.1-codex",
      "name": "openai/gpt-5.1-codex OpenAI: GPT-5.1-Codex",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.1-codex-max",
      "name": "openai/gpt-5.1-codex-max OpenAI: GPT-5.1-Codex-Max",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.1-codex-mini",
      "name": "openai/gpt-5.1-codex-mini OpenAI: GPT-5.1-Codex-Mini",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.1:batch",
      "name": "openai/gpt-5.1:batch OpenAI: GPT-5.1 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.2",
      "name": "openai/gpt-5.2 OpenAI: GPT-5.2",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.2-chat",
      "name": "openai/gpt-5.2-chat OpenAI: GPT-5.2 Chat",
      "max_tokens": 32000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.2-codex",
      "name": "openai/gpt-5.2-codex OpenAI: GPT-5.2-Codex",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.2-pro",
      "name": "openai/gpt-5.2-pro OpenAI: GPT-5.2 Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.2-pro:batch",
      "name": "openai/gpt-5.2-pro:batch OpenAI: GPT-5.2 Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.2:batch",
      "name": "openai/gpt-5.2:batch OpenAI: GPT-5.2 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.3-codex",
      "name": "openai/gpt-5.3-codex OpenAI: GPT-5.3-Codex",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.4",
      "name": "openai/gpt-5.4 OpenAI: GPT-5.4",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.4-image-2",
      "name": "openai/gpt-5.4-image-2 OpenAI: GPT-5.4 Image 2",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.4-mini",
      "name": "openai/gpt-5.4-mini OpenAI: GPT-5.4 Mini",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.4-mini:batch",
      "name": "openai/gpt-5.4-mini:batch OpenAI: GPT-5.4 Mini (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.4-nano",
      "name": "openai/gpt-5.4-nano OpenAI: GPT-5.4 Nano",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.4-nano:batch",
      "name": "openai/gpt-5.4-nano:batch OpenAI: GPT-5.4 Nano (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.4-pro",
      "name": "openai/gpt-5.4-pro OpenAI: GPT-5.4 Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.4-pro:batch",
      "name": "openai/gpt-5.4-pro:batch OpenAI: GPT-5.4 Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.4:batch",
      "name": "openai/gpt-5.4:batch OpenAI: GPT-5.4 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.5",
      "name": "openai/gpt-5.5 OpenAI: GPT-5.5",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.5-pro",
      "name": "openai/gpt-5.5-pro OpenAI: GPT-5.5 Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.5-pro:batch",
      "name": "openai/gpt-5.5-pro:batch OpenAI: GPT-5.5 Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.5:batch",
      "name": "openai/gpt-5.5:batch OpenAI: GPT-5.5 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-luna",
      "name": "openai/gpt-5.6-luna OpenAI: GPT-5.6 Luna",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-luna-pro",
      "name": "openai/gpt-5.6-luna-pro OpenAI: GPT-5.6 Luna Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-luna-pro:batch",
      "name": "openai/gpt-5.6-luna-pro:batch OpenAI: GPT-5.6 Luna Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-luna:batch",
      "name": "openai/gpt-5.6-luna:batch OpenAI: GPT-5.6 Luna (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-sol",
      "name": "openai/gpt-5.6-sol OpenAI: GPT-5.6 Sol",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-sol-pro",
      "name": "openai/gpt-5.6-sol-pro OpenAI: GPT-5.6 Sol Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-sol-pro:batch",
      "name": "openai/gpt-5.6-sol-pro:batch OpenAI: GPT-5.6 Sol Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-sol:batch",
      "name": "openai/gpt-5.6-sol:batch OpenAI: GPT-5.6 Sol (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-terra",
      "name": "openai/gpt-5.6-terra OpenAI: GPT-5.6 Terra",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-terra-pro",
      "name": "openai/gpt-5.6-terra-pro OpenAI: GPT-5.6 Terra Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-terra-pro:batch",
      "name": "openai/gpt-5.6-terra-pro:batch OpenAI: GPT-5.6 Terra Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5.6-terra:batch",
      "name": "openai/gpt-5.6-terra:batch OpenAI: GPT-5.6 Terra (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-5:batch",
      "name": "openai/gpt-5:batch OpenAI: GPT-5 (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-astra",
      "name": "openai/gpt-6-astra OpenAI: GPT-6 Astra",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-astra-pro",
      "name": "openai/gpt-6-astra-pro OpenAI: GPT-6 Astra Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-astra-pro:batch",
      "name": "openai/gpt-6-astra-pro:batch OpenAI: GPT-6 Astra Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-astra:batch",
      "name": "openai/gpt-6-astra:batch OpenAI: GPT-6 Astra (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-luna",
      "name": "openai/gpt-6-luna OpenAI: GPT-6 Luna",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-luna-decisions",
      "name": "openai/gpt-6-luna-decisions OpenAI: GPT-6 Luna Decisions",
      "max_tokens": 945000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-luna-pro",
      "name": "openai/gpt-6-luna-pro OpenAI: GPT-6 Luna Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-luna-pro:batch",
      "name": "openai/gpt-6-luna-pro:batch OpenAI: GPT-6 Luna Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-luna:batch",
      "name": "openai/gpt-6-luna:batch OpenAI: GPT-6 Luna (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-sol",
      "name": "openai/gpt-6-sol OpenAI: GPT-6 Sol",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-sol-pro",
      "name": "openai/gpt-6-sol-pro OpenAI: GPT-6 Sol Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-sol-pro:batch",
      "name": "openai/gpt-6-sol-pro:batch OpenAI: GPT-6 Sol Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6-sol:batch",
      "name": "openai/gpt-6-sol:batch OpenAI: GPT-6 Sol (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6.1-sol",
      "name": "openai/gpt-6.1-sol OpenAI: GPT-6.1 Sol",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6.1-sol-pro",
      "name": "openai/gpt-6.1-sol-pro OpenAI: GPT-6.1 Sol Pro",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6.1-sol-pro:batch",
      "name": "openai/gpt-6.1-sol-pro:batch OpenAI: GPT-6.1 Sol Pro (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6.1-sol:batch",
      "name": "openai/gpt-6.1-sol:batch OpenAI: GPT-6.1 Sol (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6.1-terra",
      "name": "openai/gpt-6.1-terra OpenAI: GPT-6.1 Terra",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-6.1-terra:batch",
      "name": "openai/gpt-6.1-terra:batch OpenAI: GPT-6.1 Terra (batch)",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-audio",
      "name": "openai/gpt-audio OpenAI: GPT Audio",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-audio-mini",
      "name": "openai/gpt-audio-mini OpenAI: GPT Audio Mini",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-chat-latest",
      "name": "openai/gpt-chat-latest OpenAI: GPT Chat Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-image-1",
      "name": "openai/gpt-image-1 OpenAI: GPT Image 1",
      "max_tokens": 360000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-image-1-mini",
      "name": "openai/gpt-image-1-mini OpenAI: GPT Image 1 Mini",
      "max_tokens": 360000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-image-2",
      "name": "openai/gpt-image-2 OpenAI: GPT Image 2",
      "max_tokens": 360000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-image-2.5-flare",
      "name": "openai/gpt-image-2.5-flare OpenAI: GPT Image 2.5 Flare",
      "max_tokens": 360000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-image-2.5-sunburst",
      "name": "openai/gpt-image-2.5-sunburst OpenAI: GPT Image 2.5 Sunburst",
      "max_tokens": 360000
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-oss-120b",
      "name": "openai/gpt-oss-120b OpenAI: gpt-oss-120b",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-oss-120b:batch",
      "name": "openai/gpt-oss-120b:batch OpenAI: gpt-oss-120b (batch)",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-oss-20b",
      "name": "openai/gpt-oss-20b OpenAI: gpt-oss-20b",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-oss-20b:batch",
      "name": "openai/gpt-oss-20b:batch OpenAI: gpt-oss-20b (batch)",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-oss-safeguard-20b",
      "name": "openai/gpt-oss-safeguard-20b OpenAI: gpt-oss-safeguard-20b",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "openai/gpt-transcribe",
      "name": "openai/gpt-transcribe OpenAI: GPT Transcribe",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "openai/o1",
      "name": "openai/o1 OpenAI: o1",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o1-pro",
      "name": "openai/o1-pro OpenAI: o1-pro",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o3",
      "name": "openai/o3 OpenAI: o3",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o3-mini",
      "name": "openai/o3-mini OpenAI: o3 Mini",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o3-mini-high",
      "name": "openai/o3-mini-high OpenAI: o3 Mini High",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o3-mini:batch",
      "name": "openai/o3-mini:batch OpenAI: o3 Mini (batch)",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o3-pro",
      "name": "openai/o3-pro OpenAI: o3 Pro",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o3:batch",
      "name": "openai/o3:batch OpenAI: o3 (batch)",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o4-mini",
      "name": "openai/o4-mini OpenAI: o4 Mini",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o4-mini-high",
      "name": "openai/o4-mini-high OpenAI: o4 Mini High",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/o4-mini:batch",
      "name": "openai/o4-mini:batch OpenAI: o4 Mini (batch)",
      "max_tokens": 100000
    },
    {
      "api": "openrouter",
      "id": "openai/whisper-1",
      "name": "openai/whisper-1 OpenAI: Whisper 1",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "openai/whisper-large-v3",
      "name": "openai/whisper-large-v3 OpenAI: Whisper Large V3",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "openai/whisper-large-v3-turbo",
      "name": "openai/whisper-large-v3-turbo OpenAI: Whisper Large V3 Turbo",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "openrouter/auto",
      "name": "openrouter/auto Auto Router"
    },
    {
      "api": "openrouter",
      "id": "openrouter/auto-beta",
      "name": "openrouter/auto-beta Auto Router (Beta)"
    },
    {
      "api": "openrouter",
      "id": "openrouter/bodybuilder",
      "name": "openrouter/bodybuilder Body Builder (beta)"
    },
    {
      "api": "openrouter",
      "id": "openrouter/free",
      "name": "openrouter/free Free Models Router"
    },
    {
      "api": "openrouter",
      "id": "openrouter/fusion",
      "name": "openrouter/fusion OpenRouter: Fusion"
    },
    {
      "api": "openrouter",
      "id": "openrouter/pareto-code",
      "name": "openrouter/pareto-code Pareto Code Router"
    },
    {
      "api": "openrouter",
      "id": "perceptron/perceptron-mk1",
      "name": "perceptron/perceptron-mk1 Perceptron: Perceptron Mk1",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "perceptron/perceptron-mk1.5",
      "name": "perceptron/perceptron-mk1.5 Perceptron: Perceptron Mk1.5",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "perplexity/pplx-decider-flash-v1.2",
      "name": "perplexity/pplx-decider-flash-v1.2 Perplexity: Decider Flash V1.2",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "perplexity/pplx-decider-v1.2",
      "name": "perplexity/pplx-decider-v1.2 Perplexity: Decider V1.2",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "perplexity/sonar",
      "name": "perplexity/sonar Perplexity: Sonar",
      "max_tokens": 114364
    },
    {
      "api": "openrouter",
      "id": "perplexity/sonar-deep-research",
      "name": "perplexity/sonar-deep-research Perplexity: Sonar Deep Research",
      "max_tokens": 115200
    },
    {
      "api": "openrouter",
      "id": "perplexity/sonar-pro",
      "name": "perplexity/sonar-pro Perplexity: Sonar Pro",
      "max_tokens": 8000
    },
    {
      "api": "openrouter",
      "id": "perplexity/sonar-pro-search",
      "name": "perplexity/sonar-pro-search Perplexity: Sonar Pro Search",
      "max_tokens": 8000
    },
    {
      "api": "openrouter",
      "id": "perplexity/sonar-reasoning-pro",
      "name": "perplexity/sonar-reasoning-pro Perplexity: Sonar Reasoning Pro",
      "max_tokens": 115200
    },
    {
      "api": "openrouter",
      "id": "poolside/laguna-s-2.1",
      "name": "poolside/laguna-s-2.1 Poolside: Laguna S 2.1",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "poolside/laguna-s-2.1:free",
      "name": "poolside/laguna-s-2.1:free Poolside: Laguna S 2.1 (free)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "poolside/laguna-xs-2.1",
      "name": "poolside/laguna-xs-2.1 Poolside: Laguna XS 2.1",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "poolside/laguna-xs-2.1:free",
      "name": "poolside/laguna-xs-2.1:free Poolside: Laguna XS 2.1 (free)",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "prism-ml/ternary-bonsai-2-27b",
      "name": "prism-ml/ternary-bonsai-2-27b PrismML: Ternary Bonsai 2 27B",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-2.5-72b-instruct",
      "name": "qwen/qwen-2.5-72b-instruct Qwen2.5 72B Instruct",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-2.5-7b-instruct",
      "name": "qwen/qwen-2.5-7b-instruct Qwen: Qwen2.5 7B Instruct",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-2.5-coder-32b-instruct",
      "name": "qwen/qwen-2.5-coder-32b-instruct Qwen2.5 Coder 32B Instruct",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-audio-3.0-tts-flash",
      "name": "qwen/qwen-audio-3.0-tts-flash Qwen: Qwen-Audio-3.0-TTS Flash",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-audio-3.0-tts-plus",
      "name": "qwen/qwen-audio-3.0-tts-plus Qwen: Qwen-Audio-3.0-TTS Plus",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-image-2.1-pro",
      "name": "qwen/qwen-image-2.1-pro Qwen: Qwen Image 2.1 Pro",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-image-2.1-turbo",
      "name": "qwen/qwen-image-2.1-turbo Qwen: Qwen Image 2.1 Turbo",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-image-3",
      "name": "qwen/qwen-image-3 Qwen: Qwen Image 3",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-image-3-pro",
      "name": "qwen/qwen-image-3-pro Qwen: Qwen Image 3 Pro",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen-plus",
      "name": "qwen/qwen-plus Qwen: Qwen-Plus",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen2.5-vl-72b-instruct",
      "name": "qwen/qwen2.5-vl-72b-instruct Qwen: Qwen2.5 VL 72B Instruct",
      "max_tokens": 115200
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-14b",
      "name": "qwen/qwen3-14b Qwen: Qwen3 14B",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-235b-a22b-2507",
      "name": "qwen/qwen3-235b-a22b-2507 Qwen: Qwen3 235B A22B Instruct 2507",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-235b-a22b-thinking-2507",
      "name": "qwen/qwen3-235b-a22b-thinking-2507 Qwen: Qwen3 235B A22B Thinking 2507",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-30b-a3b",
      "name": "qwen/qwen3-30b-a3b Qwen: Qwen3 30B A3B",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-30b-a3b-instruct-2507",
      "name": "qwen/qwen3-30b-a3b-instruct-2507 Qwen: Qwen3 30B A3B Instruct 2507",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-32b",
      "name": "qwen/qwen3-32b Qwen: Qwen3 32B",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-asr-0.6b",
      "name": "qwen/qwen3-asr-0.6b Qwen: Qwen3 ASR 0.6B",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-asr-1.7b",
      "name": "qwen/qwen3-asr-1.7b Qwen: Qwen3 ASR 1.7B",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-coder",
      "name": "qwen/qwen3-coder Qwen: Qwen3 Coder 480B A35B",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-coder-30b-a3b-instruct",
      "name": "qwen/qwen3-coder-30b-a3b-instruct Qwen: Qwen3 Coder 30B A3B Instruct",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-coder-flash",
      "name": "qwen/qwen3-coder-flash Qwen: Qwen3 Coder Flash",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-coder-next",
      "name": "qwen/qwen3-coder-next Qwen: Qwen3 Coder Next",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-next-80b-a3b-instruct",
      "name": "qwen/qwen3-next-80b-a3b-instruct Qwen: Qwen3 Next 80B A3B Instruct",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-next-80b-a3b-thinking",
      "name": "qwen/qwen3-next-80b-a3b-thinking Qwen: Qwen3 Next 80B A3B Thinking",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-reranker-8b",
      "name": "qwen/qwen3-reranker-8b Qwen3 Reranker 8B",
      "max_tokens": 36864
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-vl-235b-a22b-instruct",
      "name": "qwen/qwen3-vl-235b-a22b-instruct Qwen: Qwen3 VL 235B A22B Instruct",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-vl-30b-a3b-instruct",
      "name": "qwen/qwen3-vl-30b-a3b-instruct Qwen: Qwen3 VL 30B A3B Instruct",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-vl-30b-a3b-thinking",
      "name": "qwen/qwen3-vl-30b-a3b-thinking Qwen: Qwen3 VL 30B A3B Thinking",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3-vl-8b-instruct",
      "name": "qwen/qwen3-vl-8b-instruct Qwen: Qwen3 VL 8B Instruct",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.5-122b-a10b",
      "name": "qwen/qwen3.5-122b-a10b Qwen: Qwen3.5-122B-A10B",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.5-27b",
      "name": "qwen/qwen3.5-27b Qwen: Qwen3.5-27B",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.5-35b-a3b",
      "name": "qwen/qwen3.5-35b-a3b Qwen: Qwen3.5-35B-A3B",
      "max_tokens": 81920
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.5-397b-a17b",
      "name": "qwen/qwen3.5-397b-a17b Qwen: Qwen3.5 397B A17B",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.5-9b",
      "name": "qwen/qwen3.5-9b Qwen: Qwen3.5-9B",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.5-flash-02-23",
      "name": "qwen/qwen3.5-flash-02-23 Qwen: Qwen3.5-Flash",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.5-plus-02-15",
      "name": "qwen/qwen3.5-plus-02-15 Qwen: Qwen3.5 Plus 2026-02-15",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.5-plus-20260420",
      "name": "qwen/qwen3.5-plus-20260420 Qwen: Qwen3.5 Plus 2026-04-20",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.6-27b",
      "name": "qwen/qwen3.6-27b Qwen: Qwen3.6 27B",
      "max_tokens": 81920
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.6-35b-a3b",
      "name": "qwen/qwen3.6-35b-a3b Qwen: Qwen3.6 35B A3B",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.6-flash",
      "name": "qwen/qwen3.6-flash Qwen: Qwen3.6 Flash",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.6-plus",
      "name": "qwen/qwen3.6-plus Qwen: Qwen3.6 Plus",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.7-flash",
      "name": "qwen/qwen3.7-flash Qwen: Qwen3.7 Flash",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.7-max",
      "name": "qwen/qwen3.7-max Qwen: Qwen3.7 Max",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.7-plus",
      "name": "qwen/qwen3.7-plus Qwen: Qwen3.7 Plus",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.7-plus:batch",
      "name": "qwen/qwen3.7-plus:batch Qwen: Qwen3.7 Plus (batch)",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.8-2.4t-a95b",
      "name": "qwen/qwen3.8-2.4t-a95b Qwen: Qwen3.8 2.4T A95B",
      "max_tokens": 909000
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.8-27b",
      "name": "qwen/qwen3.8-27b Qwen: Qwen3.8 27B",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.8-flash",
      "name": "qwen/qwen3.8-flash Qwen: Qwen3.8 Flash",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.8-max-0902",
      "name": "qwen/qwen3.8-max-0902 Qwen: Qwen3.8 Max (0902)",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.8-max-prime",
      "name": "qwen/qwen3.8-max-prime Qwen: Qwen3.8 Max Prime",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "qwen/qwen3.8-omni-flash",
      "name": "qwen/qwen3.8-omni-flash Qwen: Qwen3.8 Omni Flash",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v3",
      "name": "recraft/recraft-v3 Recraft: Recraft V3",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4",
      "name": "recraft/recraft-v4 Recraft: Recraft V4",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4-pro",
      "name": "recraft/recraft-v4-pro Recraft: Recraft V4 Pro",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4-pro-vector",
      "name": "recraft/recraft-v4-pro-vector Recraft: Recraft V4 Pro Vector",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4-styles",
      "name": "recraft/recraft-v4-styles Recraft: Recraft V4 Styles",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4-styles-pro",
      "name": "recraft/recraft-v4-styles-pro Recraft: Recraft V4 Styles Pro",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4-styles-pro-vector",
      "name": "recraft/recraft-v4-styles-pro-vector Recraft: Recraft V4 Styles Pro Vector",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4-styles-vector",
      "name": "recraft/recraft-v4-styles-vector Recraft: Recraft V4 Styles Vector",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4-vector",
      "name": "recraft/recraft-v4-vector Recraft: Recraft V4 Vector",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4.1",
      "name": "recraft/recraft-v4.1 Recraft: Recraft V4.1",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4.1-flash",
      "name": "recraft/recraft-v4.1-flash Recraft: Recraft V4.1 Flash",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4.1-pro",
      "name": "recraft/recraft-v4.1-pro Recraft: Recraft V4.1 Pro",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4.1-pro-vector",
      "name": "recraft/recraft-v4.1-pro-vector Recraft: Recraft V4.1 Pro Vector",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4.1-utility",
      "name": "recraft/recraft-v4.1-utility Recraft: Recraft V4.1 Utility",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4.1-utility-pro",
      "name": "recraft/recraft-v4.1-utility-pro Recraft: Recraft V4.1 Utility Pro",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recraft/recraft-v4.1-vector",
      "name": "recraft/recraft-v4.1-vector Recraft: Recraft V4.1 Vector",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "recursive/flint-v1.0:free",
      "name": "recursive/flint-v1.0:free Recursive: Flint (free)",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "reflection/beam-1.0-501b-a23b",
      "name": "reflection/beam-1.0-501b-a23b Reflection: Beam 1.0 501B A23B",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "rekaai/reka-edge",
      "name": "rekaai/reka-edge Reka Edge",
      "max_tokens": 14745
    },
    {
      "api": "openrouter",
      "id": "rekaai/reka-flash-3",
      "name": "rekaai/reka-flash-3 Reka Flash 3",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "relace/relace-apply-3",
      "name": "relace/relace-apply-3 Relace: Relace Apply 3",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "relace/relace-search",
      "name": "relace/relace-search Relace: Relace Search",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "respan/span-01",
      "name": "respan/span-01 Respan: Span-01",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "respan/span-01-lite",
      "name": "respan/span-01-lite Respan: Span-01 Lite",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "respan/span-01-lite:free",
      "name": "respan/span-01-lite:free Respan: Span-01 Lite (free)",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "respan/span-02",
      "name": "respan/span-02 Respan: Span-02",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "runway/aleph-2",
      "name": "runway/aleph-2 Runway: Aleph 2.0",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "runway/gen-4.5",
      "name": "runway/gen-4.5 Runway: Gen-4.5",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "sakana/fugu-max",
      "name": "sakana/fugu-max Sakana: Fugu Max",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "sakana/fugu-ultra",
      "name": "sakana/fugu-ultra Sakana: Fugu Ultra",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "sakana/fugu-ultra-v2",
      "name": "sakana/fugu-ultra-v2 Sakana: Fugu Ultra v2",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "sakana/sakana-namazu",
      "name": "sakana/sakana-namazu Sakana: Sakana Namazu",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "sao10k/l3-lunaris-8b",
      "name": "sao10k/l3-lunaris-8b Sao10K: Llama 3 8B Lunaris",
      "max_tokens": 7372
    },
    {
      "api": "openrouter",
      "id": "sao10k/l3.1-euryale-70b",
      "name": "sao10k/l3.1-euryale-70b Sao10K: Llama 3.1 Euryale 70B v2.2",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "scaledown/classify-1",
      "name": "scaledown/classify-1 ScaleDown: Classify-1",
      "max_tokens": 900000
    },
    {
      "api": "openrouter",
      "id": "scaledown/extract",
      "name": "scaledown/extract ScaleDown: Extract",
      "max_tokens": 900000
    },
    {
      "api": "openrouter",
      "id": "scaledown/summarize",
      "name": "scaledown/summarize ScaleDown: Summarize",
      "max_tokens": 4000
    },
    {
      "api": "openrouter",
      "id": "sesame/csm-1b",
      "name": "sesame/csm-1b Sesame: CSM 1B",
      "max_tokens": 3686
    },
    {
      "api": "openrouter",
      "id": "sourceful/riverflow-v2-fast",
      "name": "sourceful/riverflow-v2-fast Sourceful: Riverflow V2 Fast",
      "max_tokens": 7372
    },
    {
      "api": "openrouter",
      "id": "sourceful/riverflow-v2-pro",
      "name": "sourceful/riverflow-v2-pro Sourceful: Riverflow V2 Pro",
      "max_tokens": 7372
    },
    {
      "api": "openrouter",
      "id": "sourceful/riverflow-v2.5-fast",
      "name": "sourceful/riverflow-v2.5-fast Sourceful: Riverflow V2.5 Fast",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "sourceful/riverflow-v2.5-pro",
      "name": "sourceful/riverflow-v2.5-pro Sourceful: Riverflow V2.5 Pro",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "stepfun/step-3.5-flash",
      "name": "stepfun/step-3.5-flash StepFun: Step 3.5 Flash",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "stepfun/step-3.7-flash",
      "name": "stepfun/step-3.7-flash StepFun: Step 3.7 Flash",
      "max_tokens": 230400
    },
    {
      "api": "openrouter",
      "id": "stepfun/step-5-preview",
      "name": "stepfun/step-5-preview StepFun: Step 5 Preview",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "tencent/hunyuan-a13b-instruct",
      "name": "tencent/hunyuan-a13b-instruct Tencent: Hunyuan A13B Instruct",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "tencent/hy-image-v3.5-preview",
      "name": "tencent/hy-image-v3.5-preview Tencent: Hy Image 3.5 Preview",
      "max_tokens": 90000
    },
    {
      "api": "openrouter",
      "id": "tencent/hy-mt2-1.8b",
      "name": "tencent/hy-mt2-1.8b Tencent: Hy-MT2-1.8B",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "tencent/hy-mt2-30b-a3b",
      "name": "tencent/hy-mt2-30b-a3b Tencent: Hy-MT2-30B-A3B",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "tencent/hy-mt2-7b",
      "name": "tencent/hy-mt2-7b Tencent: Hy-MT2-7B",
      "max_tokens": 4096
    },
    {
      "api": "openrouter",
      "id": "tencent/hy3",
      "name": "tencent/hy3 Tencent: Hy3",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "tencent/hy3-preview",
      "name": "tencent/hy3-preview Tencent: Hy3 preview",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "tencent/hy4-preview",
      "name": "tencent/hy4-preview Tencent: Hy4 preview",
      "max_tokens": 64000
    },
    {
      "api": "openrouter",
      "id": "thedrummer/cydonia-24b-v4.1",
      "name": "thedrummer/cydonia-24b-v4.1 TheDrummer: Cydonia 24B V4.1",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "thedrummer/skyfall-36b-v2",
      "name": "thedrummer/skyfall-36b-v2 TheDrummer: Skyfall 36B V2",
      "max_tokens": 29491
    },
    {
      "api": "openrouter",
      "id": "thedrummer/unslopnemo-12b",
      "name": "thedrummer/unslopnemo-12b TheDrummer: UnslopNemo 12B",
      "max_tokens": 819200
    },
    {
      "api": "openrouter",
      "id": "thinkingmachines/inkling",
      "name": "thinkingmachines/inkling Thinking Machines: Inkling",
      "max_tokens": 471859
    },
    {
      "api": "openrouter",
      "id": "thinkingmachines/inkling-small",
      "name": "thinkingmachines/inkling-small Thinking Machines: Inkling Small",
      "max_tokens": 262144
    },
    {
      "api": "openrouter",
      "id": "thinkingmachines/inkling-small:free",
      "name": "thinkingmachines/inkling-small:free Thinking Machines: Inkling Small (free)",
      "max_tokens": 262144
    },
    {
      "api": "openrouter",
      "id": "thinkingmachines/inkling:free",
      "name": "thinkingmachines/inkling:free Thinking Machines: Inkling (free)",
      "max_tokens": 262144
    },
    {
      "api": "openrouter",
      "id": "togethercomputer/tev1-4b-experimental",
      "name": "togethercomputer/tev1-4b-experimental Together: Tev1 4B Experimental",
      "max_tokens": 8
    },
    {
      "api": "openrouter",
      "id": "typesafe/jev-1.13",
      "name": "typesafe/jev-1.13 TypeSafe: Jev 1.13",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "typesafe/jev-1.14",
      "name": "typesafe/jev-1.14 TypeSafe: Jev 1.14",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "typesafe/jev-router",
      "name": "typesafe/jev-router TypeSafe: Jev Router",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "unbiased/pareto-26.10",
      "name": "unbiased/pareto-26.10 Pareto 26.10",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "unbiased/pareto-26.9",
      "name": "unbiased/pareto-26.9 Pareto 26.9",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "undi95/remm-slerp-l2-13b",
      "name": "undi95/remm-slerp-l2-13b ReMM SLERP 13B",
      "max_tokens": 5529
    },
    {
      "api": "openrouter",
      "id": "upstage/solar-decide",
      "name": "upstage/solar-decide Upstage: Solar Decide",
      "max_tokens": 471859
    },
    {
      "api": "openrouter",
      "id": "upstage/solar-decide-flash",
      "name": "upstage/solar-decide-flash Upstage: Solar Decide Flash",
      "max_tokens": 471859
    },
    {
      "api": "openrouter",
      "id": "upstage/solar-mini4",
      "name": "upstage/solar-mini4 Upstage: Solar Mini 4",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "upstage/solar-pro-3",
      "name": "upstage/solar-pro-3 Upstage: Solar Pro 3",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "upstage/solar-pro4",
      "name": "upstage/solar-pro4 Upstage: Solar Pro 4",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "voyageai/rerank-2.5",
      "name": "voyageai/rerank-2.5 VoyageAI by MongoDB: rerank-2.5",
      "max_tokens": 28800
    },
    {
      "api": "openrouter",
      "id": "voyageai/rerank-2.5-lite",
      "name": "voyageai/rerank-2.5-lite VoyageAI by MongoDB: rerank-2.5-lite",
      "max_tokens": 28800
    },
    {
      "api": "openrouter",
      "id": "voyageai/rerank-3",
      "name": "voyageai/rerank-3 VoyageAI by MongoDB: rerank-3",
      "max_tokens": 28800
    },
    {
      "api": "openrouter",
      "id": "voyageai/rerank-3-lite",
      "name": "voyageai/rerank-3-lite VoyageAI by MongoDB: rerank-3-lite",
      "max_tokens": 28800
    },
    {
      "api": "openrouter",
      "id": "writer/palmyra-x5",
      "name": "writer/palmyra-x5 Writer: Palmyra X5",
      "max_tokens": 8192
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-4.20",
      "name": "x-ai/grok-4.20 SpaceXAI: Grok 4.20",
      "max_tokens": 1800000
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-4.20-multi-agent",
      "name": "x-ai/grok-4.20-multi-agent SpaceXAI: Grok 4.20 Multi-Agent",
      "max_tokens": 1800000
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-4.3",
      "name": "x-ai/grok-4.3 SpaceXAI: Grok 4.3",
      "max_tokens": 900000
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-4.3:batch",
      "name": "x-ai/grok-4.3:batch SpaceXAI: Grok 4.3 (batch)",
      "max_tokens": 900000
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-4.5",
      "name": "x-ai/grok-4.5 SpaceXAI: Grok 4.5",
      "max_tokens": 450000
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-4.6",
      "name": "x-ai/grok-4.6 SpaceXAI: Grok 4.6",
      "max_tokens": 450000
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-4.7",
      "name": "x-ai/grok-4.7 SpaceXAI: Grok 4.7",
      "max_tokens": 450000
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-build-0.1",
      "name": "x-ai/grok-build-0.1 SpaceXAI: Grok Build 0.1",
      "max_tokens": 230400
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-imagine-image-2.0",
      "name": "x-ai/grok-imagine-image-2.0 xAI: Grok Imagine Image 2.0",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-imagine-image-quality",
      "name": "x-ai/grok-imagine-image-quality SpaceXAI: Grok Imagine Image Quality",
      "max_tokens": 58982
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-imagine-video",
      "name": "x-ai/grok-imagine-video SpaceXAI: Grok Imagine Video",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-imagine-video-1.5",
      "name": "x-ai/grok-imagine-video-1.5 SpaceXAI: Grok Imagine Video 1.5",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-imagine-video-1.5-lite",
      "name": "x-ai/grok-imagine-video-1.5-lite SpaceXAI: Grok Imagine Video 1.5 Lite",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-stt-1.0",
      "name": "x-ai/grok-stt-1.0 SpaceXAI: Grok STT 1.0",
      "max_tokens": 0
    },
    {
      "api": "openrouter",
      "id": "x-ai/grok-voice-tts-1.0",
      "name": "x-ai/grok-voice-tts-1.0 SpaceXAI: Grok Voice TTS 1.0",
      "max_tokens": 13500
    },
    {
      "api": "openrouter",
      "id": "xiaomi/mimo-v2.5",
      "name": "xiaomi/mimo-v2.5 Xiaomi: MiMo-V2.5",
      "max_tokens": 945000
    },
    {
      "api": "openrouter",
      "id": "xiaomi/mimo-v2.5-pro",
      "name": "xiaomi/mimo-v2.5-pro Xiaomi: MiMo-V2.5-Pro",
      "max_tokens": 945000
    },
    {
      "api": "openrouter",
      "id": "xiaomi/mimo-v2.6-flash",
      "name": "xiaomi/mimo-v2.6-flash Xiaomi: MiMo-V2.6-Flash",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "xiaomi/mimo-v2.6-pro",
      "name": "xiaomi/mimo-v2.6-pro Xiaomi: MiMo-V2.6-Pro",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "xiaomi/mimo-v2.6-pro-ultraspeed",
      "name": "xiaomi/mimo-v2.6-pro-ultraspeed Xiaomi: MiMo-V2.6-Pro-UltraSpeed",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "xingchen-agi/xing4.0-29b-a4b:free",
      "name": "xingchen-agi/xing4.0-29b-a4b:free XingChen: Xing4.0 29B A4B (free)",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-4.5",
      "name": "z-ai/glm-4.5 Z.ai: GLM 4.5",
      "max_tokens": 98304
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-4.5-air",
      "name": "z-ai/glm-4.5-air Z.ai: GLM 4.5 Air",
      "max_tokens": 98304
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-4.5v",
      "name": "z-ai/glm-4.5v Z.ai: GLM 4.5V",
      "max_tokens": 16384
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-4.6",
      "name": "z-ai/glm-4.6 Z.ai: GLM 4.6",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-4.6v",
      "name": "z-ai/glm-4.6v Z.ai: GLM 4.6V",
      "max_tokens": 32768
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-4.7",
      "name": "z-ai/glm-4.7 Z.ai: GLM 4.7",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-4.7-flash",
      "name": "z-ai/glm-4.7-flash Z.ai: GLM 4.7 Flash",
      "max_tokens": 117964
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5",
      "name": "z-ai/glm-5 Z.ai: GLM 5",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5-turbo",
      "name": "z-ai/glm-5-turbo Z.ai: GLM 5 Turbo",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5.1",
      "name": "z-ai/glm-5.1 Z.ai: GLM 5.1",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5.2",
      "name": "z-ai/glm-5.2 Z.ai: GLM 5.2",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5.3",
      "name": "z-ai/glm-5.3 Z.ai: GLM 5.3",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5.3-flash",
      "name": "z-ai/glm-5.3-flash Z.ai: GLM 5.3 Flash",
      "max_tokens": 943717
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5.3-flash:batch",
      "name": "z-ai/glm-5.3-flash:batch Z.ai: GLM 5.3 Flash (batch)",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5.3-flashx",
      "name": "z-ai/glm-5.3-flashx Z.ai: GLM 5.3 FlashX",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5.3-prime",
      "name": "z-ai/glm-5.3-prime Z.ai: GLM 5.3 Prime",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5.3:batch",
      "name": "z-ai/glm-5.3:batch Z.ai: GLM 5.3 (batch)",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "z-ai/glm-5v-turbo",
      "name": "z-ai/glm-5v-turbo Z.ai: GLM 5V Turbo",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "~anthropic/claude-fable-latest",
      "name": "~anthropic/claude-fable-latest Anthropic: Claude Fable Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "~anthropic/claude-haiku-latest",
      "name": "~anthropic/claude-haiku-latest Anthropic: Claude Haiku Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "~anthropic/claude-opus-latest",
      "name": "~anthropic/claude-opus-latest Anthropic: Claude Opus Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "~anthropic/claude-sonnet-latest",
      "name": "~anthropic/claude-sonnet-latest Anthropic: Claude Sonnet Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "~deepseek/deepseek-flash-latest",
      "name": "~deepseek/deepseek-flash-latest DeepSeek: DeepSeek Flash Latest",
      "max_tokens": 393216
    },
    {
      "api": "openrouter",
      "id": "~deepseek/deepseek-pro-latest",
      "name": "~deepseek/deepseek-pro-latest DeepSeek: DeepSeek Pro Latest",
      "max_tokens": 393216
    },
    {
      "api": "openrouter",
      "id": "~deepseek/deepseek-v4-flash-latest",
      "name": "~deepseek/deepseek-v4-flash-latest DeepSeek: DeepSeek V4 Flash Latest",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "~google/gemini-flash-latest",
      "name": "~google/gemini-flash-latest Google: Gemini Flash Latest",
      "max_tokens": 65536
    },
    {
      "api": "openrouter",
      "id": "~google/gemini-pro-latest",
      "name": "~google/gemini-pro-latest Google: Gemini Pro Latest",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "~moonshotai/kimi-latest",
      "name": "~moonshotai/kimi-latest MoonshotAI: Kimi Latest",
      "max_tokens": 943718
    },
    {
      "api": "openrouter",
      "id": "~openai/gpt-astra-latest",
      "name": "~openai/gpt-astra-latest OpenAI: GPT Astra Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "~openai/gpt-luna-latest",
      "name": "~openai/gpt-luna-latest OpenAI: GPT Luna Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "~openai/gpt-mini-latest",
      "name": "~openai/gpt-mini-latest OpenAI: GPT Mini Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "~openai/gpt-sol-latest",
      "name": "~openai/gpt-sol-latest OpenAI: GPT Sol Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "~openai/gpt-terra-latest",
      "name": "~openai/gpt-terra-latest OpenAI: GPT Terra Latest",
      "max_tokens": 128000
    },
    {
      "api": "openrouter",
      "id": "~perplexity/pplx-decider-flash-latest",
      "name": "~perplexity/pplx-decider-flash-latest Perplexity: Decider Flash Latest",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "~perplexity/pplx-decider-latest",
      "name": "~perplexity/pplx-decider-latest Perplexity: Decider Latest",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "~typesafe/jev-latest",
      "name": "~typesafe/jev-latest TypeSafe: Jev Latest",
      "max_tokens": 235929
    },
    {
      "api": "openrouter",
      "id": "~unbiased/pareto-latest",
      "name": "~unbiased/pareto-latest Pareto Latest",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "~x-ai/grok-latest",
      "name": "~x-ai/grok-latest xAI: Grok Latest",
      "max_tokens": 450000
    },
    {
      "api": "openrouter",
      "id": "~z-ai/glm-flash-latest",
      "name": "~z-ai/glm-flash-latest Z.ai: GLM Flash Latest",
      "max_tokens": 131072
    },
    {
      "api": "openrouter",
      "id": "~z-ai/glm-latest",
      "name": "~z-ai/glm-latest Z.ai: GLM Latest",
      "max_tokens": 943718
    },
    {
      "api": "codex",
      "id": "gpt-6.1-sol",
      "name": "Codex / GPT-6.1-Sol",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "max_tokens",
          "remove": true
        },
        {
          "id": "stream",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "low",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Xhigh"
            },
            {
              "value": "max",
              "label": "Max"
            },
            {
              "value": "ultra",
              "label": "Ultra"
            }
          ]
        }
      ]
    },
    {
      "api": "codex",
      "id": "gpt-6-astra",
      "name": "Codex / GPT-6-Astra",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "max_tokens",
          "remove": true
        },
        {
          "id": "stream",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "low",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Xhigh"
            },
            {
              "value": "max",
              "label": "Max"
            },
            {
              "value": "ultra",
              "label": "Ultra"
            }
          ]
        }
      ]
    },
    {
      "api": "codex",
      "id": "gpt-6-sol",
      "name": "Codex / GPT-6-Sol",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "max_tokens",
          "remove": true
        },
        {
          "id": "stream",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Xhigh"
            },
            {
              "value": "max",
              "label": "Max"
            },
            {
              "value": "ultra",
              "label": "Ultra"
            }
          ]
        }
      ]
    },
    {
      "api": "codex",
      "id": "gpt-6-luna",
      "name": "Codex / GPT-6-Luna",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "max_tokens",
          "remove": true
        },
        {
          "id": "stream",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Xhigh"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        }
      ]
    },
    {
      "api": "codex",
      "id": "gpt-5.6-sol",
      "name": "Codex / GPT-5.6-Sol",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "max_tokens",
          "remove": true
        },
        {
          "id": "stream",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "low",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Xhigh"
            },
            {
              "value": "max",
              "label": "Max"
            },
            {
              "value": "ultra",
              "label": "Ultra"
            }
          ]
        }
      ]
    },
    {
      "api": "codex",
      "id": "gpt-5.6-terra",
      "name": "Codex / GPT-5.6-Terra",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "max_tokens",
          "remove": true
        },
        {
          "id": "stream",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Xhigh"
            },
            {
              "value": "max",
              "label": "Max"
            },
            {
              "value": "ultra",
              "label": "Ultra"
            }
          ]
        }
      ]
    },
    {
      "api": "codex",
      "id": "gpt-5.6-luna",
      "name": "Codex / GPT-5.6-Luna",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "max_tokens",
          "remove": true
        },
        {
          "id": "stream",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Xhigh"
            },
            {
              "value": "max",
              "label": "Max"
            }
          ]
        }
      ]
    },
    {
      "api": "codex",
      "id": "gpt-5.5",
      "name": "Codex / GPT-5.5",
      "params": [
        {
          "id": "temperature",
          "remove": true
        },
        {
          "id": "top_p",
          "remove": true
        },
        {
          "id": "frequency_penalty",
          "remove": true
        },
        {
          "id": "presence_penalty",
          "remove": true
        },
        {
          "id": "max_tokens",
          "remove": true
        },
        {
          "id": "stream",
          "remove": true
        },
        {
          "id": "reasoning_effort",
          "key": "reasoning_effort",
          "widget": "select",
          "label": "Reasoning Effort",
          "initial_value": "medium",
          "options": [
            {
              "value": "low",
              "label": "Low"
            },
            {
              "value": "medium",
              "label": "Medium"
            },
            {
              "value": "high",
              "label": "High"
            },
            {
              "value": "xhigh",
              "label": "Xhigh"
            }
          ]
        }
      ]
    }
  ]
}